import Vue from "vue";
import Router from "vue-router";
import store from "@/state/store";
import CryptoJS from "crypto-js";

// Component Wrapper
const Wrapper = () =>
  import(/* webpackChunkName: "wrapper-page" */ "@/components/wrapper/Administrator.vue");

// Begin SPPD
// import Sppd from '@/views/sppd/Sppd.vue'
const Sppd = () =>
  import(/* webpackChunkName: "Sppd" */ "@/views/sppd/Sppd.vue");
const DataList = () =>
  import(/* webpackChunkName: "Datalist" */ "@/views/sppd/DataList.vue");
const SppdCreate = () =>
  import(/* webpackChunkName: "SppdCreate" */ "@/views/sppd/CreateSppd.vue");
const SppdManifest = () =>
  import(/* webpackChunkName: "SppdManifest" */ "@/views/sppd/Manifest.vue");
const SppdPublicManifest = () =>
  import(
    /* webpackChunkName: "SppdPublicManifest" */ "@/views/sppd/ManifestApproval.vue"
  );
// End SPPD

// Begin Handle View
const P404 = () =>
  import(/* webpackChunkName: "P404" */ "@/views/handleView/404.vue");
const PNoCon = () =>
  import(
    /* webpackChunkName: "PNoCon" */ "@/views/handleView/noConnection.vue"
  );
// End HAndle View

// Begin Beranda
const Beranda = () =>
  import(/* webpackChunkName: "Beranda" */ "@/views/beranda/beranda.vue");
// End Beranda

// Begin Umpd
const UmPd = () =>
  import(/* webpackChunkName: "UmPd" */ "@/views/umpd/UmPd.vue");
const ListUmPd = () =>
  import(/* webpackChunkName: "ListUmPd" */ "@/views/umpd/ListUmpd.vue");
const UmpdCreate = () =>
  import(/* webpackChunkName: "UmpdCreate" */ "@/views/umpd/UmpdCreate.vue");
const UmpdManifest = () =>
  import(
    /* webpackChunkName: "UmpdManifest" */ "@/views/umpd/UmpdManifest.vue"
  );
const UmpdPublicManifest = () =>
  import(
    /* webpackChunkName: "UmpdPublicManifest" */ "@/views/umpd/ManifestApproval.vue"
  );
// End Umpd

// Begin Purchasing
const Purchasing = () =>
  import(
    /* webpackChunkName: "Purchasing" */ "@/views/purchasing/Purchasing.vue"
  );
const PurchasingBoard = () =>
  import(
    /* webpackChunkName: "PurchasingBoard" */ "@/views/purchasing/PurchasingBoard.vue"
  );
const Supplier = () =>
  import(/* webpackChunkName: "Supplier" */ "@/views/purchasing/Supplier.vue");
const SpclSupplier = () =>
  import(
    /* webpackChunkName: "SpclSupplier" */ "@/views/specialMenu/supplier/specialDataList.vue"
  );
const PurchasingManifest = () =>
  import(
    /* webpackChunkName: "PurchasingManifest" */ "@/views/purchasing/Manifest.vue"
  );
const PurchasingCreate = () =>
  import(
    /* webpackChunkName: "PurchasingCreate" */ "@/views/purchasing/Create.vue"
  );
const SupplierPublicManifest = () =>
  import(
    /* webpackChunkName: "SupplierPublicManifest" */ "@/views/purchasing/ManifestApproval.vue"
  );
// const SpclPriorityList = () =>
//   import(
//     /* webpackChunkName: "SpclPODataList" */ "@/views/specialMenu/pp/specialPriorityList.vue"
//   );
const SpclPriorityList_v2 = () =>
  import(
    /* webpackChunkName: "SpclPODataList" */ "@/views/specialMenu/pp/specialPriorityList_v2.vue"
  );
// End Purchasing

// Begin Atasan Langsung
const AtasanLangsung = () =>
  import(
    /* webpackChunkName: "AtasanLangsung" */ "@/views/atasanLangsung/index.vue"
  );
const AtasanLangsungBoard = () =>
  import(
    /* webpackChunkName: "AtasanLangsungBoard" */ "@/views/atasanLangsung/atasanLangsungBoard.vue"
  );
const spclQueueAL = () =>
  import(
    /* webpackChunkName: "spclQueueAL" */ "@/views/atasanLangsung/ppQueue.vue"
  );
// End Atasan Langsung

// Begin Pimpro
const Pimpro = () =>
  import(/* webpackChunkName: "Pimpro" */ "@/views/pimpro/index.vue");
const PimproBoard = () =>
  import(
    /* webpackChunkName: "PimproBoard" */ "@/views/pimpro/pimproBoard.vue"
  );
// End Pimpro

// Begin Direktur
const Direktur = () =>
  import(/* webpackChunkName: "Direktur" */ "@/views/direktur/index.vue");
const DirekturBoard = () =>
  import(
    /* webpackChunkName: "DirekturBoard" */ "@/views/direktur/direkturBoard.vue"
  );
const SpclProyekDirektur = () =>
  import(
        /* webpackChunkName: "AnggaranDirektur" */ "@/views/direktur/anggaran/ListAnggaran.vue"
  );
const SpclManifestProyekDirektur = () =>
  import(
        /* webpackChunkName: "AnggaranManifestDirektur" */ "@/views/direktur/anggaran/Manifest.vue"
  );
const SpclProyekWrapperDirektur = () =>
  import(
        /* webpackChunkName: "AnggaranDirektur" */ "@/views/direktur/anggaran/Wrapper.vue"
  );
// End Direktur

// Begin Director Delegation
const DirectorDelegation = () =>
  import(/* webpackChunkName: "DirectorDelegation" */ "@/views/directorDelegation/index.vue");
const DirectorDelegationBoard = () =>
  import(
    /* webpackChunkName: "DirectorDelegationBoard" */ "@/views/directorDelegation/directorDelegationBoard.vue"
  );
// End Director Delegation

// Begin HRD
const Hrd = () => import(/* webpackChunkName: "Hrd" */ "@/views/hrd/index.vue");
const HrdBoard = () =>
  import(/* webpackChunkName: "HrdBoard" */ "@/views/hrd/hrdBoard.vue");
// End HRD

// Begin HRD
const SiteJakarta = () =>
  import(/* webpackChunkName: "SiteJakarta" */ "@/views/siteJakarta/index.vue");
const SiteJakartaBoard = () =>
  import(
    /* webpackChunkName: "SiteJakartaBoard" */ "@/views/siteJakarta/siteJakartaBoard.vue"
  );
// End HRD

// Begin Cooperative
const CooperativeIndex = () =>
  import(
    /* webpackChunkName: "CooperativeIndex" */ "@/views/cooperative/Index.vue"
  );
const CooperativeBoard = () =>
  import(
    /* webpackChunkName: "CooperativeBoard" */ "@/views/cooperative/Board.vue"
  );
const CooperativeDeductionWrapper = () =>
  import(
    /* webpackChunkName: "CooperativeDeductionWrapper" */ "@/views/cooperative/cooperativeDeduction/Wrapper.vue"
  );
const CooperativeDeduction = () =>
  import(
    /* webpackChunkName: "CooperativeDeduction" */ "@/views/cooperative/cooperativeDeduction/List.vue"
  );
const CooperativeDeductionCreate = () =>
  import(
    /* webpackChunkName: "CooperativeDeductionCreate" */ "@/views/cooperative/cooperativeDeduction/Create.vue"
  );
const CooperativeDeductionManifest = () =>
  import(
    /* webpackChunkName: "CooperativeDeductionManifest" */ "@/views/cooperative/cooperativeDeduction/Manifest.vue"
  );
// End Cooperative

// Begin Cop
const CopIndex = () =>
  import(
    /* webpackChunkName: "CopIndex" */ "@/views/cop/Index.vue"
  );
const CopWrapper = () =>
  import(
    /* webpackChunkName: "CopWrapper" */ "@/views/cop/board.vue"
  );
const CopDeduction = () =>
  import(
    /* webpackChunkName: "CopDeduction" */ "@/views/cop/copPayment/List.vue"
  );
const CopDeductionCreate = () =>
  import(
    /* webpackChunkName: "CopDeductionCreate" */ "@/views/cop/copPayment/Create.vue"
  );
const CopDeductionManifest = () =>
  import(
    /* webpackChunkName: "CopDeductionManifest" */ "@/views/cop/copPayment/Manifest.vue"
  );
// End Cop

// Begin GA
const Ga = () => import(/* webpackChunkName: "Ga" */ "@/views/ga/index.vue");
const GaBoard = () =>
  import(/* webpackChunkName: "GaBoard" */ "@/views/ga/gaBoard.vue");
// const GaPriority = () =>
//   import(/* webpackChunkName: "Ga" */ "@/views/ga/PpPriority.vue");
const GaPriority_v2 = () =>
  import(/* webpackChunkName: "Ga" */ "@/views/ga/PpPriority_v2.vue");
// const SpclPrio = () =>
//   import(
//     /* webpackChunkName: "Ga" */ "@/views/specialMenu/priority/ga/specialPriorityList.vue"
//   );
const SpclPrio_v2 = () =>
  import(
    /* webpackChunkName: "Ga" */ "@/views/specialMenu/priority/ga/specialPriorityList_v2.vue"
  );
// const PrioPurchasing = () =>
//   import(
//     /* webpackChunkName: "Ga" */ "@/views/specialMenu/priority/purchasing/PpPriority.vue"
//   );

const PrioPurchasing_v2 = () =>
  import(
    /* webpackChunkName: "Ga" */ "@/views/specialMenu/priority/purchasing/PpPriority_v2.vue"
  );
// End GA

// Begin verifikatorPelaporan
const VerifikatorPelaporan = () =>
  import(
    /* webpackChunkName: "VerifikatorPelaporan" */ "@/views/verifikatorPelaporan/Index.vue"
  );
const VerifikatorPelaporanBoard = () =>
  import(
    /* webpackChunkName: "VerifikatorPelaporanBoard" */ "@/views/verifikatorPelaporan/Board.vue"
  );
// End verifikatorPelaporan

// Begin PP
const PP = () => import(/* webpackChunkName: "PP" */ "@/views/pp/Index.vue");
const PPBoard = () =>
  import(/* webpackChunkName: "PPBoard" */ "@/views/pp/ListPP.vue");
const PPManifest = () =>
  import(/* webpackChunkName: "PPManifest" */ "@/views/pp/Manifest.vue");
const PPCreate = () =>
  import(/* webpackChunkName: "PPCreate" */ "@/views/pp/Create.vue");
const ListUmPp = () =>
  import(/* webpackChunkName: "ListUmPp" */ "@/views/pp/umpp/ListUmpp");
const UmppCreate = () =>
  import(/* webpackChunkName: "UmppCreate" */ "@/views/pp/umpp/UmppCreate");
const UmppManifest = () =>
  import(/* webpackChunkName: "UmppManifest" */ "@/views/pp/umpp/UmppManifest");
const PpPublicManifest = () =>
  import(
    /* webpackChunkName: "PpPublicManifest" */ "@/views/pp/ManifestApproval"
  );
const UmppPublicManifest = () =>
  import(
    /* webpackChunkName: "UmppPublicManifest" */ "@/views/pp/umpp/ManifestApproval"
  );
// End SPPD

// Begin Login
// import LoginProcess from '@/views/proses/LoginProcess'
// End Login

// Begin Logout
const LogoutProcess = () =>
  import(
    /* webpackChunkName: "LogoutProcess" */ "@/views/proses/LogOutProcess"
  );
// End Logout

// Begin Laporan UM PP
const LaporanUMPP = () =>
  import(/* webpackChunkName: "LaporanUMPP" */ "@/views/pp/laporan/Index");
const LaporanList = () =>
  import(/* webpackChunkName: "LaporanList" */ "@/views/pp/laporan/List");
const LaporanManifestPublic = () =>
  import(
    /* webpackChunkName: "LaporanManifestPublic" */ "@/views/pp/laporan/ManifestOutside"
  );
const LaporanUmppCreate = () =>
  import(
    /* webpackChunkName: "LaporanUmppCreate" */ "@/views/pp/laporan/Create"
  );
const LaporanUmppManifest = () =>
  import(
    /* webpackChunkName: "LaporanUmppManifest" */ "@/views/pp/laporan/Manifest"
  );
const LapUmPPPublicManifest = () =>
  import(
    /* webpackChunkName: "LapUmPPPublicManifest" */ "@/views/pp/laporan/ManifestApproval"
  );
// End Laporan UM PP

// Begin Laporan Kegiatan PD
const LaporanPD = () =>
  import(
    /* webpackChunkName: "LaporanPD" */ "@/views/sppd/laporanKegiatan/Index"
  );
const LaporanPDList = () =>
  import(
    /* webpackChunkName: "LaporanPDList" */ "@/views/sppd/laporanKegiatan/ListLapKegPd"
  );
const LaporanPDListCreate = () =>
  import(
    /* webpackChunkName: "LaporanPDListCreate" */ "@/views/sppd/laporanKegiatan/Create"
  );
const ManifestLapPD = () =>
  import(
    /* webpackChunkName: "ManifestLapPD" */ "@/views/sppd/laporanKegiatan/Manifest"
  );
const LapPDPublicManifest = () =>
  import(
    /* webpackChunkName: "LapPDPublicManifest" */ "@/views/sppd/laporanKegiatan/ManifestApproval"
  );

// End Laporan Kegiatan PD

// Begin PO
const PO = () => import(/* webpackChunkName: "PO" */ "@/views/po/Index.vue");
const ListPO = () =>
  import(/* webpackChunkName: "ListPO" */ "@/views/po/ListPO");
const PoManifest = () =>
  import(/* webpackChunkName: "PoManifest" */ "@/views/po/PoManifest");
const CreatePo = () =>
  import(/* webpackChunkName: "CreatePo" */ "@/views/po/CreatePo");
const PoPublicManifest = () =>
  import(
    /* webpackChunkName: "PoPublicManifest" */ "@/views/po/ManifestApproval.vue"
  );
// End PO

// Begin WO
const WO = () => import(/* webpackChunkName: "WO" */ "@/views/wo/Index.vue");
const WOBoard = () =>
  import(/* webpackChunkName: "WOBoard" */ "@/views/wo/ListWO.vue");
const WOCreate = () =>
  import(/* webpackChunkName: "WOCreate" */ "@/views/wo/Create.vue");
const WOManifest = () =>
  import(/* webpackChunkName: "WOManifest" */ "@/views/wo/Manifest.vue");
const WoPublicManifest = () =>
  import(
    /* webpackChunkName: "WoPublicManifest" */ "@/views/wo/ManifestApproval.vue"
  );
// End WO

// Begin Laporan UM PD
const LaporanUMPD = () =>
  import(
    /* webpackChunkName: "LaporanUMPD" */ "@/views/sppd/laporan/IndexLaporanUmPd"
  );
const LaporanListUmPd = () =>
  import(
    /* webpackChunkName: "LaporanListUmPd" */ "@/views/sppd/laporan/ListLaporanUmPd"
  );
const ManifestLaporanUmpd = () =>
  import(
    /* webpackChunkName: "ManifestLaporanUmpd" */ "@/views/sppd/laporan/ManifestLaporanUmpd"
  );
const LaporanUmpdCreate = () =>
  import(
    /* webpackChunkName: "LaporanUmpdCreate" */ "@/views/sppd/laporan/CreateLaporanUmpd"
  );
const LMOUmpd = () =>
  import(
    /* webpackChunkName: "LMOUmpd" */ "@/views/sppd/laporan/ManifestOutside"
  );
const LapUmPDPublicManifest = () =>
  import(
    /* LapUmPDPublicManifest: "Datalist" */ "@/views/sppd/laporan/ManifestApproval"
  );
// End Laporan UM PD

// Begin Keuangan
const Keuangan = () =>
  import(/* webpackChunkName: "Keuangan" */ "@/views/keuangan/Index.vue");
const KeuanganDashboard = () =>
  import(
    /* webpackChunkName: "KeuanganDashboard" */ "@/views/keuangan/Dashboard.vue"
  );

// Begin Akuntansi Keuangan
const AkuntansiKeuangan = () =>
  import(/* webpackChunkName: "AkuntansiKeuangan" */ "@/views/akuntansiKeuangan/Index.vue");
const AkuntansiKeuanganDashboard = () =>
  import(
    /* webpackChunkName: "AkuntansiKeuanganDashboard" */ "@/views/akuntansiKeuangan/Dashboard.vue"
  );
// End Akuntansi Keuangan

// Begin Akuntansi
const Akuntansi = () =>
  import(/* webpackChunkName: "Akuntansi" */ "@/views/akuntansi/Index.vue");
const AkuntansiDashboard = () =>
  import(
    /* webpackChunkName: "AkuntansiDashboard" */ "@/views/akuntansi/Dashboard.vue"
  );
const MasterCoa = () =>
  import(
    /* webpackChunkName: "MasterCoa" */ "@/views/akuntansi/COA/CreateList.vue"
  );
const MasterCostPool = () =>
  import(
    /* webpackChunkName: "MasterCostPool" */ "@/views/akuntansi/CostPool/CreateList.vue"
  );  
// End Akuntansi

// ProyekRab
const ProyekRab = () =>
  import(
    /* webpackChunkName: "ProyekRab" */ "@/views/keuangan/proyekrab/Index.vue"
  );
const ListProyekRab = () =>
  import(
    /* webpackChunkName: "ListProyekRab" */ "@/views/keuangan/proyekrab/List.vue"
  );
const CreateProyekRab = () =>
  import(
    /* webpackChunkName: "CreateProyekRab" */ "@/views/keuangan/proyekrab/Create.vue"
  );
const ManifestRab = () =>
  import(
    /* webpackChunkName: "ManifestRab" */ "@/views/keuangan/proyekrab/Manifest.vue"
  );
const ProjectPublicManifest = () =>
  import(
    /* webpackChunkName: "ProjectPublicManifest" */ "@/views/keuangan/proyekrab/ManifestApproval.vue"
  );
// End Keuangan


// Begin staff marketing
const StaffMarketingBoard = () =>
  import(/* webpackChunkName: "StaffMarketingBoard" */ "@/views/staffMarketing/StaffBoard.vue");
const StaffMarketing = () =>
  import(/* webpackChunkName: "StaffMarketing" */ "@/views/staffMarketing/Index.vue");
// End staff marketing

// Begin Marketing
const Marketing = () =>
  import(/* webpackChunkName: "Marketing" */ "@/views/marketing/Marketing.vue");
const MarketingBoard = () =>
  import(
    /* webpackChunkName: "MarketingBoard" */ "@/views/marketing/MarketingBoard.vue"
  );
const SalesNotificationIndex = () =>
  import(
    /* webpackChunkName: "SalesNotificationIndex" */ "@/views/marketing/sales_notification/Index.vue"
  );
const SalesNotification = () =>
  import(
    /* webpackChunkName: "SalesNotification" */ "@/views/marketing/sales_notification/SalesNotification.vue"
  );
const SalesNotificationManifest = () =>
  import(
    /* webpackChunkName: "SalesNotificationManifest" */ "@/views/marketing/sales_notification/Manifest.vue"
  );
const SalesNotificationCreate = () =>
  import(
    /* webpackChunkName: "SalesNotificationCreate" */ "@/views/marketing/sales_notification/Create.vue"
  );
const SalesNotifPublicManifest = () =>
  import(
    /* webpackChunkName: "SalesNotifPublicManifest" */ "@/views/marketing/ManifestApproval.vue"
  );
const FinancingPublicManifest = () =>
  import(
    /* webpackChunkName: "FinancingPublicManifest" */ "@/views/keuangan/financing/ManifestApproval.vue"
  );
const landingSalesContract = () =>
  import(
    /* webpackChunkName: "LandingSalesContract" */ "@/views/salesContract/Index.vue"
  );
const SalesContract = () =>
  import(
    /* webpackChunkName: "SalesContract" */ "@/views/salesContract/List.vue"
  );
const SalesContractManifestWrapper = () =>
  import(
    /* webpackChunkName: "SalesContractManifestWrapper" */ "@/views/salesContract/manifest/Wrapper.vue"
  );
const SalesContractManifestHistory = () =>
  import(
    /* webpackChunkName: "SalesContractManifestHistory" */ "@/views/salesContract/manifest/History.vue"
  );
const SalesContractManifest = () =>
  import(
    /* webpackChunkName: "SalesContractManifest" */ "@/views/salesContract/manifest/Index.vue"
  );
const SalesContractCreate = () =>
  import(
    /* webpackChunkName: "SalesContractCreate" */ "@/views/salesContract/Create.vue"
  );
// End Marketing

// Begin Klaim PD
const KlaimPd = () =>
  import(/* webpackChunkName: "KlaimPd" */ "@/views/sppd/klaim/IndexKlaimPd");
const KlaimListPd = () =>
  import(
    /* webpackChunkName: "KlaimListPd" */ "@/views/sppd/klaim/ListKlaimPd"
  );
const KlaimManifestPd = () =>
  import(
    /* webpackChunkName: "KlaimManifestPd" */ "@/views/sppd/klaim/ManifestKlaimPd"
  );
const KlaimPdCreate = () =>
  import(
    /* webpackChunkName: "KlaimPdCreate" */ "@/views/sppd/klaim/CreateKlaimPd"
  );
const KlaimPuManifestPd = () =>
  import(
    /* webpackChunkName: "KlaimPuManifestPd" */ "@/views/sppd/klaim/ManifestOutside"
  );
const KlaimBiayaPDPublicManifest = () =>
  import(
    /* webpackChunkName: "KlaimBiayaPDPublicManifest" */ "@/views/sppd/klaim/ManifestApproval"
  );
// End Klaim PD

// Begin Klaim Pp
const KlaimPp = () =>
  import(/* webpackChunkName: "KlaimPp" */ "@/views/pp/klaim/IndexKlaimPp");
const KlaimListPp = () =>
  import(/* webpackChunkName: "KlaimListPp" */ "@/views/pp/klaim/ListKlaimPp");
const KlaimPpCreate = () =>
  import(
    /* webpackChunkName: "KlaimPpCreate" */ "@/views/pp/klaim/CreateKlaimPp"
  );
const KlaimManifestPp = () =>
  import(
    /* webpackChunkName: "ManifestKlaimPp" */ "@/views/pp/klaim/ManifestKlaimPp"
  );
const KlaimPuManifestPpApproval = () =>
  import(
    /* webpackChunkName: "KlaimPuManifestPpApproval" */ "@/views/pp/klaim/ManifestApproval"
  );
const KlaimPuManifestPp = () =>
  import(
    /* webpackChunkName: "KlaimPuManifestPp" */ "@/views/pp/klaim/ManifestOutside"
  );

// End Klaim Pp

// Begin SpecialSPPD
const SpclSPPDDataList = () =>
  import(
    /* webpackChunkName: "SpclSPPDDataList" */ "@/views/specialMenu/sppd/specialDataList.vue"
  );
const SpclSppdManifest = () =>
  import(
    /* webpackChunkName: "SpclSppdManifest" */ "@/views/sppd/Manifest.vue"
  );
// End SpecialSPPD

// Begin SpecialUMPD
const SpclUMPDDataList = () =>
  import(
    /* webpackChunkName: "SpclUMPDDataList" */ "@/views/specialMenu/umpd/specialDataList.vue"
  );
const SpclUMPDManifest = () =>
  import(
    /* webpackChunkName: "SpclUMPDManifest" */ "@/views/umpd/UmpdManifest.vue"
  );
// End SpecialUMPD

// Begin SpecialLapUMPD
const SpclLapUMPDDataList = () =>
  import(
    /* webpackChunkName: "SpclLapUMPDDataList" */ "@/views/specialMenu/lapumpd/specialDataList.vue"
  );
const SpclLapUMPDManifest = () =>
  import(
    /* webpackChunkName: "SpclLapUMPDManifest" */ "@/views/sppd/laporan/ManifestLaporanUmpd.vue"
  );
// End SpecialLapUMPD

// Begin SpecialKlaimPD
const SpclKlaimPDDataList = () =>
  import(
    /* webpackChunkName: "SpclKlaimPDDataList" */ "@/views/specialMenu/klaimpd/specialDataList.vue"
  );
const SpclKlaimPDManifest = () =>
  import(
    /* webpackChunkName: "SpclKlaimPDManifest" */ "@/views/sppd/klaim/ManifestKlaimPd.vue"
  );
// End SpecialKlaimPD

// Begin SpecialPP
const SpclPPDataList = () =>
  import(
    /* webpackChunkName: "SpclPPDataList" */ "@/views/specialMenu/pp/specialDataList.vue"
  );
const SpclPPDataListOPC = () =>
  import(
    /* webpackChunkName: "SpclPPDataListOPC" */ "@/views/specialMenu/pp/specialDataListOPC.vue"
  );
const SpclPPManifest = () =>
  import(/* webpackChunkName: "SpclPPManifest" */ "@/views/pp/Manifest.vue");
// End SpecialPP

// Begin SpecialUMPP
const SpclUMPPDataList = () =>
  import(
    /* webpackChunkName: "SpclUMPPDataList" */ "@/views/specialMenu/umpp/specialDataList.vue"
  );
const SpclUMPPManifest = () =>
  import(
    /* webpackChunkName: "SpclUMPPManifest" */ "@/views/pp/umpp/UmppManifest.vue"
  );
// End SpecialUMPP

// Begin SpecialKlaimPP
const SpclKlaimPPDataList = () =>
  import(
    /* webpackChunkName: "SpclKlaimPPDataList" */ "@/views/specialMenu/klaimpp/specialDataList.vue"
  );
const SpclKlaimPPManifest = () =>
  import(
    /* webpackChunkName: "SpclKlaimPDManifest" */ "@/views/pp/klaim/ManifestKlaimPp.vue"
  );
// End SpecialKlaimPP

// Begin Specail Klaim CC PP
const SpclKlaimCCPP = () =>
  import(
    /* webpackChunkName: "SpclKlaimCCPP" */ "@/views/specialMenu/klaimCcPp/specialDataList.vue"
  );

// Begin SpecialPP
const SpclPODataList = () =>
  import(
    /* webpackChunkName: "SpclPODataList" */ "@/views/specialMenu/po/specialDataList.vue"
  );
const SpclPOManifest = () =>
  import(/* webpackChunkName: "SpclPOManifest" */ "@/views/po/PoManifest.vue");
// End SpecialPP

// Begin SpecialWO
const SpclWODataList = () =>
  import(
    /* webpackChunkName: "SpclWODataList" */ "@/views/specialMenu/wo/specialDataList.vue"
  );
const SpclWOManifest = () =>
  import(/* webpackChunkName: "SpclWOManifest" */ "@/views/wo/Manifest.vue");
// End SpecialWO

// Begin SpecialLapUMPP
const SpclLapUMPPDataList = () =>
  import(
    /* webpackChunkName: "SpclLapUMPPDataList" */ "@/views/specialMenu/lapumpp/specialDataList.vue"
  );
const SpclLapUMPPManifest = () =>
  import(
    /* webpackChunkName: "SpclLapUMPPManifest" */ "@/views/pp/laporan/Manifest.vue"
  );
// End SpecialLapUMPP

// Begin Special Kas Kecil
const SpclKasKecilDataList = () =>
  import(
    /* webpackChunkName: "SpclKasKecilDataList" */ "@/views/specialMenu/kaskecil/specialDataList.vue"
  );
const SpclKasKecilManifest = () =>
  import(
    /* webpackChunkName: "SpclKasKecilManifest" */ "@/views/kaskecil/laporan/ManifestKasKecil.vue"
  );
// End Special Kas Kecil

// Begin Special ProyekRAB
const SpclProyekRabDataList = () =>
  import(
    /* webpackChunkName: "SpclProyekRabDataList" */ "@/views/specialMenu/proyekRab/specialDataList.vue"
  );
const SpclProyekRabManifest = () =>
  import(
    /* webpackChunkName: "SpclProyekRabManifest" */ "@/views/keuangan/proyekrab/Manifest.vue"
  );
// End Special ProyekRAB

// Begin Special SalesNotification
const SpclSalesNotificationDataList = () =>
  import(
    /* webpackChunkName: "SpclSalesNotificationDataList" */ "@/views/specialMenu/salesNotification/specialDataList.vue"
  );
const SpclSalesNotificationManifest = () =>
  import(
    /* webpackChunkName: "SpclSalesNotificationManifest" */ "@/views/marketing/sales_notification/Manifest.vue"
  );
// End Special SalesNotification

// Begin Special Laporan Kegiatan PD
const SpclLapKegPdDataList = () =>
  import(
    /* webpackChunkName: "SpclLapKegPdDataList" */ "@/views/specialMenu/lapkegpd/specialDataList.vue"
  );
const SpclLapKegPdManifest = () =>
  import(
    /* webpackChunkName: "SpclLapKegPdManifest" */ "@/views/sppd/laporanKegiatan/Manifest.vue"
  );
// End Special Laporan Kegiatan PD

// Begin SpecialPI
const SpclPIDataList = () =>
  import(
    /* webpackChunkName: "SpclUMPPDataList" */ "@/views/specialMenu/pi/specialDataList.vue"
  );
//const SpclPIManifest = () =>
//  import(/* webpackChunkName: "SpclUMPPManifest" */ "@/views/pp/umpp/UmppManifest.vue");
// End SpecialPI

// Begin Kas Kecil
const LaporanKasKecil = () =>
  import(
    /* webpackChunkName: "LaporanKasKecil" */ "@/views/kaskecil/laporan/IndexKasKecil"
  );
const LaporanListKasKecil = () =>
  import(
    /* webpackChunkName: "LaporanListKasKecil" */ "@/views/kaskecil/laporan/ListKasKecil"
  );
const LaporanManifestKasKecil = () =>
  import(
    /* webpackChunkName: "LaporanManifestKasKecil" */ "@/views/kaskecil/laporan/ManifestKasKecil"
  );
const KasKecilCreate = () =>
  import(
    /* webpackChunkName: "KasKecilCreate" */ "@/views/kaskecil/laporan/CreateKasKecil"
  );
const KkPublicManifest = () =>
  import(
    /* webpackChunkName: "KkPublicManifest" */ "@/views/kaskecil/laporan/ManifestOutside"
  );
const KasKecilPublicManifest = () =>
  import(
    /* webpackChunkName: "KasKecilPublicManifest" */ "@/views/kaskecil/laporan/ManifestApproval"
  );
const KlaimManifestDirektur = () =>
  import(
    /* webpackChunkName: "KlaimManifestDirektur" */ "@/views/klaimDirektur/KlaimManifestDirektur"
  );
// End Kas Kecil

// Begin Anggaran
const Anggaran = () =>
  import(
    /* webpackChunkName: "Anggaran" */ "@/views/akuntansiKeuangan/anggaran/IndexAnggaran"
  );
const AnggaranList = () =>
  import(
    /* webpackChunkName: "AnggaranList" */ "@/views/akuntansiKeuangan/anggaran/ListAnggaran"
  );
const ManifestAnggaran = () =>
  import(
    /* webpackChunkName: "AnggaranManifest" */ "@/views/akuntansiKeuangan/anggaran/Manifest.vue"
  );
const ManifestAnggaranDraft = () =>
  import(
    /* webpackChunkName: "AnggaranManifest" */ "@/views/akuntansiKeuangan/anggaran/Manifest_draft.vue"
  );
const ManifestAnggaranHistory = () =>
  import(
    /* webpackChunkName: "AnggaranManifest" */ "@/views/akuntansiKeuangan/anggaran/Manifest_history.vue"
  );
const CreateAnggaran = () =>
  import(
    /* webpackChunkName: "AnggaranCreate" */ "@/views/akuntansiKeuangan/anggaran/Create.vue"
  );
// End Anggaran
// Begin Simulasi Anggaran
const SimulasiAnggaran = () =>
  import(
    /* webpackChunkName: "Anggaran" */ "@/views/akuntansiKeuangan/simulasi_anggaran/IndexSimulasiAnggaran"
  );
const SimulasiAnggaranList = () =>
  import(
    /* webpackChunkName: "AnggaranList" */ "@/views/akuntansiKeuangan/simulasi_anggaran/ListSimulasiAnggaran"
  );
const ManifestSimulasiAnggaran = () =>
  import(
    /* webpackChunkName: "AnggaranManifest" */ "@/views/akuntansiKeuangan/simulasi_anggaran/Manifest.vue"
  );
const CreateSimulasiAnggaran = () =>
  import(
    /* webpackChunkName: "AnggaranCreate" */ "@/views/akuntansiKeuangan/simulasi_anggaran/Create.vue"
  );
// End Simulasi Anggaran

// Begin PI
const PI = () => import(/* webpackChunkName: "PO" */ "@/views/pi/Index.vue");
const ListPI = () =>
  import(/* webpackChunkName: "ListPO" */ "@/views/pi/ListPI");
const PiManifest = () =>
  import(/* webpackChunkName: "PoManifest" */ "@/views/pi/Manifest");
const CreatePi = () =>
  import(/* webpackChunkName: "CreatePi" */ "@/views/pi/CreatePi.vue");
//const PoPublicManifest = () =>
//  import(/* webpackChunkName: "PoPublicManifest" */ "@/views/po/ManifestApproval.vue");
// End PI

// Begin BKKRelease
const BkkRelease = () =>
  import(/* webpackChunkName: "BkkRelease" */ "@/views/bkk/BkkRelease.vue");

const BkkReleaseAcc = () =>
  import(/* webpackChunkName: "BkkRelease" */ "@/views/akuntansiKeuangan/bkk/BkkRelease.vue");

const Bkk = () =>
  import(/* webpackChunkName: "BkkRelease" */ "@/views/bkk/Bkk.vue");

const BkkManifest = () =>
  import(/* webpackChunkName: "PoManifest" */ "@/views/bkk/ManifestBKK");

const BkkManifestAcc = () =>
  import(/* webpackChunkName: "PoManifest" */ "@/views/bkk/ManifestBKK");
// End BKKRelease

const ManifestOtherIncome = () =>
  import(
    /* webpackChunkName: "ManifestOtherIncome" */ "@/views/keuangan/otherincome/Manifest.vue"
  );


const ManifestFinancing = () =>
  import(
    /* webpackChunkName: "ManifestFinancing" */ "@/views/keuangan/financing/Manifest.vue"
  );

// Begin Account Pay
const AccountPayIndex = () =>
  import(
    /* webpackChunkName: "AccountPay" */ "@/views/keuangan/accountpay/Index.vue"
  );

const AccountPayWrapper = () =>
  import(
    /* webpackChunkName: "AccountPayWrapper" */ "@/views/keuangan/accountpay/Wrapper.vue"
  );

const AccountPayManifest = () =>
  import(
    /* webpackChunkName: "AccountPayManifest" */ "@/views/keuangan/accountpay/Manifest.vue"
  );

const AccountPayCreate = () =>
  import(
    /* webpackChunkName: "AccountPayCreate" */ "@/views/keuangan/accountpay/create/Create.vue"
  );
// End Account Pay

// Begin Payment Schedule
const PaymentScheduleIndex = () =>
  import(
        /* webpackChunkName: "PaymentSchedule" */ "@/views/keuangan/paymentSchedule/Index.vue"
  );

const PaymentScheduleWrapper = () =>
  import(
        /* webpackChunkName: "AccountPayWrapper" */ "@/views/keuangan/paymentSchedule/Wrapper.vue"
  );

const ManifestPaymentSchedule = () =>
  import(
        /* webpackChunkName: "ManifestPaymentSchedule" */ "@/views/keuangan/paymentSchedule/Manifest.vue"
  );

// End PaymentSchedule

// Begin Addendum
const SpclAdendumList = () =>
  import(
    /* webpackChunkName: "SpclAdendumList" */ "@/views/specialMenu/adendum/specialDataList.vue"
  );
// import(
//   /* webpackChunkName: "SpclAdendumList" */ "@/views/specialMenu/adendum/specialDataList.vue"
// );
const Addendum = () =>
  import(/* webpackChunkName: "Addendum" */ "@/views/addendum/Index.vue");
const ListAddendum = () =>
  import(
    /* webpackChunkName: "ListAddendum" */ "@/views/addendum/ListAddendum.vue"
  );
const AddendumCreate = () =>
  import(
    /* webpackChunkName: "AddendumCreate" */ "@/views/addendum/Create.vue"
  );
const ManifestAddendum = () =>
  import(
        /* webpackChunkName: "AddendumManifest" */ "@/views/addendum/Manifest.vue"
  );
// End Addendum

// Begin Klaim Direktur
const WrapperKlaimDirektur = () =>
  import(
    /* webpackChunkName: "wrapper-klaim-direktur" */ "@/views/klaimDirektur/Wrapper.vue"
  );

const KlaimDirektur = () =>
  import(
    /* webpackChunkName: "klaim-direktur" */ "@/views/klaimDirektur/Index.vue"
  );

const CreateKlaimDirektur = () =>
  import(
    /* webpackChunkName: "create-klaim-direktur" */ "@/views/klaimDirektur/Create.vue"
  );

const DirekturKlaimManifest = () =>
  import(
    /* webpackChunkName: "DirekturKlaimManifest" */ "@/views/klaimDirektur/Manifest.vue"
  );

const SpclKlaimDirektur = () =>
  import(
    /* webpackChunkName: "DirekturKlaimManifest" */ "@/views/specialMenu/klaimdirektur/specialDataList.vue"
  );
// End Klaim Direktur

const SpclKlaimCc = () =>
  import(
    /* webpackChunkName: "DirekturKlaimCcManifest" */ "@/views/specialMenu/klaimCc/specialDataList.vue"
  );
// End Klaim Direktur

// klaim Tiket
const SpclKlaimCCTiket = () =>
import(
  /* webpackChunkName: "KlaimCCTiket" */ "@/views/specialMenu/klaimCcTiket/specialDataList.vue"
);

const SpclKlaimCCTiketCreate = () =>
  import(
    /* webpackChunkName: "KlaimCCTiketCreate" */ "@/views/specialMenu/klaimCcTiket/create.vue"
  );

const SpclKlaimCCTiketManifest = () =>
  import(
    /* webpackChunkName: "KlaimCCTiketManifest" */ "@/views/specialMenu/klaimCcTiket/manifest.vue"
  );

const KlaimCcTiketPuManifest = () =>
  import(
    /* webpackChunkName: "DirekturKlaimCcManifest" */ "@/views/specialMenu/klaimCcTiket/manifestPublic.vue"
  );

// Start Account Mutation
const AccountMutationIndex = () =>
  import(
    /* webpackChunkName: "AccountMutationIndex" */ "@/views/keuangan/accountMutation/Index"
  );
const AccountMutationList = () =>
  import(
    /* webpackChunkName: "AccountMutationList" */ "@/views/keuangan/accountMutation/ListaccountMutation.vue"
  );
const AccountMutationCreate = () =>
  import(
    /* webpackChunkName: "AccountMutationIndex" */ "@/views/keuangan/accountMutation/Create"
  );
const ManifestAccountMutation = () =>
  import(
    /* webpackChunkName: "ManifestAccountMutation" */ "@/views/keuangan/accountMutation/Manifest.vue"
  );
// End Account Mutation

const OtherIncome = () =>
  import(
        /* webpackChunkName: "OtherIncome" */ "@/views/keuangan/otherincome/Index.vue"
  );
const OtherIncomeWrapper = () =>
  import(
        /* webpackChunkName: "AccountReceiveWrapper" */ "@/views/keuangan/otherincome/Wrapper.vue"
  );

const OtherIncomeCreate = () =>
  import(
        /* webpackChunkName: "OtherIncome" */ "@/views/keuangan/otherincome/create/Create.vue"
  );

const BKMIndex = () =>
  import(
        /* webpackChunkName: "BKMIndex" */ "@/views/keuangan/bkm/Index.vue"
  );

const BKMWrapper = () =>
  import(
        /* webpackChunkName: "bkm" */ "@/views/keuangan/bkm/Wrapper.vue"
  );

const BkmManifest = () =>
  import(/* webpackChunkName: "BKMManifest" */ "@/views/keuangan/bkm/ManifestBKM");

// Begin Account Receiveable
const AccountReceiveIndex = () =>
  import(
    /* webpackChunkName: "AccountReceiveIndex" */ "@/views/keuangan/accountReceiveable/Index.vue"
  );

const AccountReceiveWrapper = () =>
  import(
    /* webpackChunkName: "AccountReceiveWrapper" */ "@/views/keuangan/accountReceiveable/Wrapper.vue"
  );

const AccountReceiveManifest = () =>
  import(
    /* webpackChunkName: "AccountReceiveManifest" */ "@/views/keuangan/accountReceiveable/Manifest.vue"
  );

const AccountReceiveCreateGeneral = () =>
  import(
    /* webpackChunkName: "AccountReceiveCreate" */ "@/views/keuangan/accountReceiveable/create/CreateGeneral.vue"
  );

const AccountReceiveCreateNGeneral = () =>
  import(
    /* webpackChunkName: "AccountReceiveCreate" */ "@/views/keuangan/accountReceiveable/create/Create_v2.vue"
  );

const AccountReceiveEditNGeneral = () =>
  import(
    /* webpackChunkName: "AccountReceiveEditNGeneral" */ "@/views/keuangan/accountReceiveable/create/Edit.vue"
  );
// End Account Receiveable

// Begin Financing
const FinancingIndex = () =>
  import(
    /* webpackChunkName: "financing" */ "@/views/keuangan/financing/Index.vue"
  );
const FinancingList = () =>
  import(
    /* webpackChunkName: "financing-list" */ "@/views/keuangan/financing/List.vue"
  );
const SpclFinancingList = () =>
    import(
      /* webpackChunkName: "SpclFinancingList" */ "@/views/specialMenu/financing/specialDataList.vue"
    );
const FinancingCreate = () =>
  import(
    /* webpackChunkName: "financing-create" */ "@/views/keuangan/financing/Create.vue"
  );
// End Financing

// Begin Financing
const PenarikanFinancingIndex = () =>
  import(
    /* webpackChunkName: "penarikan-financing" */ "@/views/keuangan/penarikanFinancing/Index.vue"
  );
const PenarikanFinancingList = () =>
  import(
    /* webpackChunkName: "penarikan-financing-list" */ "@/views/keuangan/penarikanFinancing/List.vue"
  );
const SpclPenarikanFinancingList = () =>
    import(
      /* webpackChunkName: "SpclPenarikanFinancingList" */ "@/views/specialMenu/penarikanFinancing/specialDataList.vue"
    );
const PenarikanFinancingCreate = () =>
  import(
    /* webpackChunkName: "penarikan-financing-create" */ "@/views/keuangan/penarikanFinancing/Create.vue"
  );
const PenarikanFinancingManifest = () =>
  import(
    /* webpackChunkName: "penarikan-financing-manifest" */ "@/views/keuangan/penarikanFinancing/Manifest.vue"
  );
// End Financing

//Start Termin Release
const TerminReleaseIndex = () =>
  // import(
  //   /* webpackChunkName: "TerminReleaseIndex" */ "@/views/pimpro/terminRelease/Index.vue"
  // );
  import(
    /* webpackChunkName: "TerminReleaseIndex" */ "@/views/terminRelease/Index.vue"
    );

const TerminReleaseList = () =>
  import(
    /* webpackChunkName: "TerminReleaseList" */ "@/views/terminRelease/List.vue"
  );

const TerminReleaseCreate = () =>
  import(
    /* webpackChunkName: "TerminReleaseCreate" */ "@/views/terminRelease/Create.vue"
  );

const TerminReleaseManifest = () =>
  import(
    /* webpackChunkName: "TerminReleaseManifest" */ "@/views/terminRelease/Manifest.vue"
  );
  
//End Termin Release

// Begin bank account
const BankAccountIndex = () =>
  import(
    /* webpackChunkName: "bank-account" */ "@/views/keuangan/bankAccount/Index.vue"
  );
const BankAccountList = () =>
  import(
    /* webpackChunkName: "bank-account-list" */ "@/views/keuangan/bankAccount/List.vue"
  );
const BankAccountCreate = () =>
  import(
    /* webpackChunkName: "bank-account-create" */ "@/views/keuangan/bankAccount/Create.vue"
  );
const BankAccountEdit = () =>
  import(
    /* webpackChunkName: "bank-account-edit" */ "@/views/keuangan/bankAccount/Create.vue"
  );

// Begin Administrator Page
const Admin = () =>
  import(
    /* webpackChunkName: "admin-page" */ "@/views/admin/index.vue"
  );
const MasterIntervalWorkflow = () =>
  import(
    /* webpackChunkName: "master-interval-workflow-page" */ "@/views/admin/intervalWorkflow.vue"
  );

// Begin VPF
const Vpf = () =>
  import(/* webpackChunkName: "VPF" */ "@/views/vicePresidentFinance/index.vue");
const VpfBoard = () =>
  import(
    /* webpackChunkName: "VPFBoard" */ "@/views/vicePresidentFinance/direkturBoard.vue"
  );
const SpclProyekVpf = () =>
  import(
        /* webpackChunkName: "AnggaranVPF" */ "@/views/vicePresidentFinance/anggaran/ListAnggaran.vue"
  );
const SpclManifestProyekVpf = () =>
  import(
        /* webpackChunkName: "AnggaranManifestVPF" */ "@/views/vicePresidentFinance/anggaran/Manifest.vue"
  );
const SpclProyekWrapperVpf = () =>
  import(
        /* webpackChunkName: "AnggaranVPF" */ "@/views/vicePresidentFinance/anggaran/Wrapper.vue"
  );
// End VPF

//start Rekonsiliasi
const ReconciliationIndex = () =>
  import(
    /* webpackChunkName: "ReconciliationIndex" */ "@/views/akuntansiKeuangan/reconciliation/Index.vue"
  );

const ReconciliationWrapper = () =>
  import(
    /* webpackChunkName: "AccountPayWrapper" */ "@/views/akuntansiKeuangan/reconciliation/Wrapper.vue"
  );
  const ReconciliationDetil = () =>
  import(
    /* webpackChunkName: "ReconciliationDetil" */ "@/views/akuntansiKeuangan/reconciliation/Detil.vue"
  );

const ReconciliationManifest = () =>
  import(
    /* webpackChunkName: "AccountPayManifest" */ "@/views/akuntansiKeuangan/reconciliation/Manifest.vue"
  );
//end Rekonsiliasi

//start Bank Guarantee
const BankGuaranteeIndex = () =>
  import(
    /* webpackChunkName: "BankGuaranteeIndex" */ "@/views/keuangan/bankguarantee/Index.vue"
  );

const BankGuaranteeWrapper = () =>
  import(
    /* webpackChunkName: "BankGuaranteeWrapper" */ "@/views/keuangan/bankguarantee/Wrapper.vue"
  );

const BankGuaranteeManifest = () =>
  import(
    /* webpackChunkName: "BankGuaranteeManifest" */ "@/views/keuangan/bankguarantee/Manifest.vue"
  );
//end Bank Guarantee

// Begin Cash On Hand
const CashOnHandIndex = () =>
  import(
    /* webpackChunkName: "CashOnHandIndex" */ "@/views/keuangan/cashOnHand/Index.vue"
  );

const CashOnHandWrapper = () =>
  import(
    /* webpackChunkName: "CashOnHandWrapper" */ "@/views/keuangan/cashOnHand/Wrapper.vue"
  );

const CashOnHandManifest = () =>
  import(
    /* webpackChunkName: "CashOnHandManifest" */ "@/views/keuangan/cashOnHand/Manifest.vue"
  );
// End Cash On Hand

// Begin Bid Bond
const BidBondRequestIndex = () =>
  import(
    /* webpackChunkName: "bidBondRequestIndex" */ "@/views/bidBondRequest/Index.vue"
  );
const BidBondRequestList = () =>
  import(
    /* webpackChunkName: "bidBondRequestList-list" */ "@/views/bidBondRequest/List.vue"
  );
const BidBondRequestCreate = () =>
  import(
    /* webpackChunkName: "guaranteeCreate-create" */ "@/views/bidBondRequest/Create.vue"
  );
const BidBondRequestFinancing = () =>
  import(
    /* webpackChunkName: "bidBondRequestFinancing" */ "@/views/bidBondRequest/Manifest.vue"
  );
const BidBondRequestPublicManifest = () =>
  import(
    /* webpackChunkName: "BidBondRequestPublicManifest" */ "@/views/bidBondRequest/ManifestApproval.vue"
  );
// End Bid Bond

// Begin Bid Bond
const BidBondIndex = () =>
  import(
    /* webpackChunkName: "Index" */ "@/views/bidBond/Index.vue"
  );
const  BidBondList = () =>
  import(
    /* webpackChunkName: "bidBond-list" */ "@/views/bidBond/List.vue"
  );
const  BidBondCreate = () =>
  import(
    /* webpackChunkName: "bidBond-create" */ "@/views/bidBond/Create.vue"
  );
const  BidBondFinancing = () =>
  import(
    /* webpackChunkName: "bidBondFinancing" */ "@/views/bidBond/Manifest.vue"
  );
// End  Bid Bond

// Begin Piutang Karyawan
const PiutangkaryawanIndex = () =>
  import(
    /* webpackChunkName: "PiutangkaryawanIndex" */ "@/views/keuangan/piutangKaryawan/Index.vue"
  );
const PiutangkaryawanList = () =>
  import(
    /* webpackChunkName: "Piutangkaryawan-list" */ "@/views/keuangan/piutangKaryawan/List.vue"
  );
const PiutangkaryawanCreate = () =>
  import(
    /* webpackChunkName: "Piutangkaryawan-create" */ "@/views/keuangan/piutangKaryawan/Create.vue"
  );
const PiutangkaryawanManifest = () =>
  import(
    /* webpackChunkName: "Piutangkaryawan-manifest" */ "@/views/keuangan/piutangKaryawan/Manifest.vue"
  );
const PiutangkaryawanPublicManifest = () =>
  import(
    /* webpackChunkName: "piutangkaryawanPublicManifest" */ "@/views/keuangan/piutangKaryawan/ManifestApproval"
  );
// End Piutang Karyawan

//Begin Pembayaran Piutang
const PembayaranpiutangIndex = () =>
  import(
    /* webpackChunkName: "PembayaranpiutangIndex" */ "@/views/hrd/pembayaranPiutang/index.vue"
  );
const PembayaranpiutangList = () =>
  import(
    /* webpackChunkName: "Pembayaranpiutang-list" */ "@/views/hrd/pembayaranPiutang/List.vue"
  );
const PembayaranpiutangCreate = () =>
  import(
    /* webpackChunkName: "Pembayaranpiutang-create" */ "@/views/hrd/pembayaranPiutang/Create.vue"
  );
const PembayaranpiutangManifest = () =>
  import(
    /* webpackChunkName: "Pembayaranpiutang-manifest" */ "@/views/hrd/pembayaranPiutang/Manifest.vue"
  );
  const PembayaranPiutangkaryawanPublicManifest = () =>
  import(
    /* webpackChunkName: "PembayaranPiutangkaryawanPublicManifest" */ "@/views/hrd/pembayaranPiutang/ManifestApproval"
  );

// End Piutang Karyawan

// Begin Salary Component
const SalaryComponentIndex = () =>
  import(
    /* webpackChunkName: "SalaryComponentIndex" */ "@/views/hrd/salaryComponent/Index.vue"
  );
const SalaryComponentList = () =>
  import(
    /* webpackChunkName: "SalaryComponent" */ "@/views/hrd/salaryComponent/List.vue"
  );
const SalaryComponentCreate = () =>
  import(
    /* webpackChunkName: "SalaryComponentCreate" */ "@/views/hrd/salaryComponent/Create.vue"
  );
const SalaryComponentManifest = () =>
  import(
    /* webpackChunkName: "SalaryComponentManifest" */ "@/views/hrd/salaryComponent/Manifest.vue"
  );
// End Salary Component

//start Supplier Evaluation
  const SupplierEvaluationIndex = () =>
  import(/* webpackChunkName: "supplierEvaluationIndex" */ "@/views/supplierEvaluation/Index.vue");

const SupplierEvaluation = () =>
  import(/* webpackChunkName: "SupplierEvaluation" */ "@/views/supplierEvaluation/List.vue");
  
const SupplierEvaluationCreate = () =>
  import(/* webpackChunkName: "supplierEvaluation-create" */ "@/views/supplierEvaluation/Create.vue");

const SupplierEvaluationManifest = () =>
  import(/* webpackChunkName: "supplierEvaluationManifest" */ "@/views/supplierEvaluation/Manifest.vue");

const SupplierEvaluationPublicManifest = () =>
  import(
    /* webpackChunkName: "SupplierEvaluationPublicManifest" */ "@/views/supplierEvaluation/ManifestApproval.vue"
  );
//end Supplier Evaluation

//start Other Outcome
const OtherOutcome = () =>
  import(
        /* webpackChunkName: "OtherOutcome" */ "@/views/keuangan/otheroutcome/Index.vue"
  );
const OtherOutcomeWrapper = () =>
  import(
        /* webpackChunkName: "OtherOutcomeWrapper" */ "@/views/keuangan/otheroutcome/Wrapper.vue"
  );
const OtherOutcomeCreate = () =>
  import(
        /* webpackChunkName: "OtherOutcome" */ "@/views/keuangan/otheroutcome/create/Create.vue"
  );
  const ManifestOtherOutcome = () =>
  import(
    /* webpackChunkName: "ManifestOtherIncome" */ "@/views/keuangan/otheroutcome/Manifest.vue"
  );
//End Other Outcome

// Begin Operation Planning and Control
const Opc = () =>
  import(/* webpackChunkName: "Direktur" */ "@/views/opc/index.vue");
const OpcBoard = () =>
  import(
    /* webpackChunkName: "DirekturBoard" */ "@/views/opc/opcBoard.vue"
  );
// End Operation Planning and Control

// Begin Closing UM
const ClosingUM = () =>
  import(/* webpackChunkName: "closingUM" */ "@/views/keuangan/closingUM/Index.vue");
const ClosingUMWrapper = () =>
  import(
    /* webpackChunkName: "ClosingUMWrapper" */ "@/views/keuangan/closingUM/Wrapper.vue"
  );
const Closingmanifest = () =>
  import(
    /* webpackChunkName: "Closingmanifest" */ "@/views/keuangan/closingUM/Manifest.vue"
  );
// End Closing UM

// Begin Closing UM by Upload BA
const ClosingUMbyUploadBA = () =>
  import(/* webpackChunkName: "ClosingUMbyUploadBA" */ "@/views/keuangan/closingUMbyAploadBA/Index.vue");
const ClosingUMWrapperbyUploadBA = () =>
  import(
    /* webpackChunkName: "ClosingUMWrapperbyUploadBA" */ "@/views/keuangan/closingUMbyAploadBA/Wrapper.vue"
  );
const ClosingmanifestbyUploadBA = () =>
  import(
    /* webpackChunkName: "ClosingmanifestbyUploadBA" */ "@/views/keuangan/closingUMbyAploadBA/Manifest.vue"
  );
// End Closing UM by Upload BA

//start Refund Payment
const RefundPayment = () =>
  import(
        /* webpackChunkName: "RefundPayment" */ "@/views/refundPayment/Index.vue"
  );
const RefundPaymentWrapper = () =>
  import(
        /* webpackChunkName: "RefundPaymentWrapper" */ "@/views/refundPayment/Wrapper.vue"
  );
const RefundPaymentCreate = () =>
  import(
        /* webpackChunkName: "RefundPaymentCreate" */ "@/views/refundPayment/create/Create.vue"
  );
  const ManifestRefundPayment = () =>
  import(
    /* webpackChunkName: "ManifestRefundPayment" */ "@/views/refundPayment/Manifest.vue"
  );
//End Refund Payment

// Begin TaxOfficer
const TaxOfficer = () => import(/* webpackChunkName: "TaxOfficer" */ "@/views/taxOfficer/index.vue");
const TaxOfficerBoard = () =>
  import(/* webpackChunkName: "TaxOfficerBoard" */ "@/views/taxOfficer/TaxOfficerBoard.vue");
const MonitoringTax = () =>
  import(/* webpackChunkName: "MonitoringTax" */ "@/views/taxOfficer/List.vue");
// End TaxOfficer

// Begin Tax Verification
//const TaxVerification = () => import(/* webpackChunkName: "TaxVerification" */ "@/views/taxVerification/index.vue");
const MonitoringTaxVerification = () =>
  import(/* webpackChunkName: "MonitoringTaxVerification" */ "@/views/taxVerification/List.vue");
// End Tax Verification

// Begin Monitoring Faktur
const MonitoringFaktur = () =>
  import(/* webpackChunkName: "MonitoringFaktur" */ "@/views/monFaktur/List.vue");
// End Monitoring Faktur

// Begin Invoice
const InvoiceIndex = () =>
  import(
    /* webpackChunkName: "InvoiceIndex" */ "@/views/keuangan/invoice/List.vue"
  );

const InvoiceWrapper = () =>
  import(
    /* webpackChunkName: "InvoiceWrapper" */ "@/views/keuangan/invoice/Wrapper.vue"
  );

const InvoiceManifest = () =>
  import(
    /* webpackChunkName: "InvoiceManifest" */ "@/views/keuangan/invoice/Manifest.vue"
  );

const InvoiceCreate = () =>
  import(
    /* webpackChunkName: "InvoiceCreate" */ "@/views/keuangan/invoice/create/Create.vue"
  );
// End Invoice

const ChangeLogs = () =>
  import(
    /* webpackChunkName: "ChangeLogs" */ "@/components/ChangeLogs.vue"
  );

// Begin SPT  
const SPT = () => import(/* webpackChunkName: "SPT" */ "@/views/spt/Index.vue");
const SPTCreate = () =>
  import(/* webpackChunkName: "SPTCreate" */ "@/views/spt/Create.vue");
const SPTEdit = () =>
  import(/* webpackChunkName: "SPTEdit" */ "@/views/spt/Create.vue");
const SPTManifest = () =>
  import(/* webpackChunkName: "SPTManifest" */ "@/views/spt/Manifest.vue");
// End SPT

// Begin Master Kode Setoran  
const MasterKodeSetoran = () => import(/* webpackChunkName: "MasterKodeSetoran" */ "@/views/master/kode_setoran/List.vue");
// End Master Kode Setoran

// Begin Kompensasi
const Compensation = () => import(/* webpackChunkName: "Compensation" */ "@/views/compensation/List.vue");
// End Kompensasi

// Begin Tax Release
const TaxRelease = () => import(/* webpackChunkName: "TaxRelease" */ "@/views/taxRelease/List.vue");
// End Tax Release

// Begin SPT Monitoring
const SPTMonIndex = () => import(/* webpackChunkName: "SPTMonIndex" */ "@/views/sptMonitoring/Index.vue");
const SPTList = () =>
  import(/* webpackChunkName: "SPTList" */ "@/views/sptMonitoring/List");
const SPTRecapList = () =>
  import(/* webpackChunkName: "SPTRecapList" */ "@/views/sptMonitoring/ListRecapitulation");
// End SPT Monitoring

// Begin PBK
const PBKList = () => import(/* webpackChunkName: "PBKList" */ "@/views/pbk/List");
const PBKManifest = () => import(/* webpackChunkName: "PBKManifest" */ "@/views/pbk/Manifest");
const PBKCreate = () => import(/* webpackChunkName: "PBKCreate" */ "@/views/pbk/Create");
// End PBK

// Begin AR Accounting
const ARAccountingIndex = () =>
  import(
    /* webpackChunkName: "ARAccountingIndex" */ "@/views/akuntansi/ARAccounting/Index.vue"
  );

const ARAccountingWrapper = () =>
  import(
    /* webpackChunkName: "ARAccountingWrapper" */ "@/views/akuntansi/ARAccounting/Wrapper.vue"
  );

const ARAccountingManifest = () =>
  import(
    /* webpackChunkName: "ARAccountingManifest" */ "@/views/akuntansi/ARAccounting/Manifest.vue"
  );

const ARAccountingCreateGeneral = () =>
  import(
    /* webpackChunkName: "ARAccountingCreateGeneral" */ "@/views/akuntansi/ARAccounting/create/CreateGeneral.vue"
  );

const ARAccountingCreateNGeneral = () =>
  import(
    /* webpackChunkName: "ARAccountingCreateNGeneral" */ "@/views/akuntansi/ARAccounting/create/Create_v2.vue"
  );

const ARAccountingEditNGeneral = () =>
  import(
    /* webpackChunkName: "ARAccountingEditNGeneral" */ "@/views/akuntansi/ARAccounting/create/Edit.vue"
  );
// End AR Accounting

// Start PIRelease
const PIRelease = () =>
  import(/* webpackChunkName: "PIRelease" */ "@/views/piRelease/Release.vue");
const ManifestPIRelease = () =>
  import(/* webpackChunkName: "ManifestPIRelease" */ "@/views/piRelease/Manifest.vue");
// End PIRelease

// Start RecapitulaionRelease
const RecapitulationRelease = () =>
  import(/* webpackChunkName: "RecapitulationRelease" */ "@/views/RecapitulationRelease/Release.vue");
const ManifestRecapitulationRelease = () =>
  import(/* webpackChunkName: "ManifestRecapitulationRelease" */ "@/views/RecapitulationRelease/Manifest.vue");
// End RecapitulaionRelease

// Start RNDNotification
const RNDNotificationIndex = () =>
  import(
    /* webpackChunkName: "RNDNotificationIndex" */ "@/views/rnd_notification/Index.vue"
  );
const RNDNotification = () =>
  import(
    /* webpackChunkName: "RNDNotification" */ "@/views/rnd_notification/RNDNotification.vue"
  );
const RNDNotificationManifest = () =>
  import(
    /* webpackChunkName: "RNDNotificationManifest" */ "@/views/rnd_notification/Manifest.vue"
  );
const RNDNotificationCreate = () =>
  import(
    /* webpackChunkName: "RNDNotificationCreate" */ "@/views/rnd_notification/Create.vue"
  );
// End RNDNotification

// Begin PipeLine
const PipelineIndex = () =>
  import(
    /* webpackChunkName: "PipelineIndex" */ "@/views/pipeline/Index.vue"
  );

const PipelineWrapper = () =>
  import(
    /* webpackChunkName: "PipelineWrapper" */ "@/views/pipeline/Wrapper.vue"
  );

const PipelineManifest = () =>
  import(
    /* webpackChunkName: "PipelineManifest" */ "@/views/pipeline/Manifest.vue"
  );
const PipelinePublicManifest = () =>
  import(
    /* webpackChunkName: "PipelinePublicManifest" */ "@/views/pipeline/PublicManifest.vue"
  );
// End PipeLine

// Begin PipeLine
const ProjectProgressIndex = () =>
  import(
    /* webpackChunkName: "ProjectProgressIndex" */ "@/views/projectProgress/Index.vue"
  );

const ProjectProgressWrapper = () =>
  import(
    /* webpackChunkName: "ProjectProgressWrapper" */ "@/views/projectProgress/Wrapper.vue"
  );
// End PipeLine

// Begin cash management
const AnnualPlafon = () =>
  import(
    /* webpackChunkName: "AnnualPlafon" */ "@/views/cashManagement/annualPlafon.vue"
  );
const MonthlyPlafon = () =>
  import(
    /* webpackChunkName: "MonthlyPlafon" */ "@/views/cashManagement/monthlyPlafon.vue"
);
const ManifestAnnualMonthly = () =>
  import(
    /* webpackChunkName: "ManifestAnnualMonthly" */ "@/views/cashManagement/manifest.vue"
  );
  const ManifestPublicAnnualMonthly = () =>
    import(
      /* webpackChunkName: "ManifestPublicAnnualMonthly" */ "@/views/cashManagement/manifestApproval.vue"
    );
// End cash management


//Start Customer
const landingCustomer = () =>
  import(
    /* webpackChunkName: "LandingCustomer" */ "@/views/customer/Index.vue"
  );
const Customer = () =>
  import(
    /* webpackChunkName: "Customer" */ "@/views/customer/List.vue"
  );
//End Customer

// Begin FinancialControl
const FinancialControl = () =>
  import(/* webpackChunkName: "FinancialControl" */ "@/views/financialControl/index.vue");
const FinancialControlBoard = () =>
  import(
    /* webpackChunkName: "FinancialControlBoard" */ "@/views/financialControl/board.vue"
  );
// End FinancialControl

// Start Klaim CC
const KlaimCCIndex = () =>
  import(
    /* webpackChunkName: "KlaimCCIndex" */ "@/views/klaimCC/Index.vue"
  );
const KlaimCC = () =>
  import(
    /* webpackChunkName: "KlaimCC" */ "@/views/klaimCC/List.vue"
  );
const KlaimCCManifest = () =>
  import(
    /* webpackChunkName: "klaimCCManifest" */ "@/views/klaimCC/Manifest.vue"
  );
const KlaimCCCreate = () =>
  import(
    /* webpackChunkName: "KlaimCCCreate" */ "@/views/klaimCC/Create.vue"
  );
  const KlaimCCManifestPublic = () =>
    import(
      /* webpackChunkName: "KlaimCCManifestPublic" */ "@/views/klaimCC/KlaimCCPublicManifest"
    );
// End Klaim CC

//start Credit Card
const CreditCardIndex = () =>
  import(
    /* webpackChunkName: "CreditCardIndex" */ "@/views/creditCard/Index.vue"
  );

const CreditCardWrapper = () =>
  import(
    /* webpackChunkName: "CreditCardWrapper" */ "@/views/creditCard/Wrapper.vue"
  );

const CreditCardManifest = () =>
  import(
    /* webpackChunkName: "CreditCardManifest" */ "@/views/creditCard/Manifest.vue"
  );
//end Credit Card

// Begin Klaim CC Pp
const KlaimCCPp = () =>
  import(/* webpackChunkName: "KlaimCCPp" */ "@/views/klaimCCPP/IndexKlaimCCPp");
const KlaimListCCPp = () =>
  import(/* webpackChunkName: "KlaimListCCPp" */ "@/views/klaimCCPP/ListKlaimCCPp");
const KlaimCCPpCreate = () =>
  import(
    /* webpackChunkName: "KlaimCCPpCreate" */ "@/views/klaimCCPP/CreateKlaimCCPp"
  );
const KlaimManifestCCPp = () =>
  import(
    /* webpackChunkName: "ManifestKlaimCCPp" */ "@/views/klaimCCPP/ManifestKlaimCCPp"
  );
const KlaimPuManifestCCPp = () =>
  import(
    /* webpackChunkName: "KlaimPuManifestCCPp" */ "@/views/klaimCCPP/ManifestOutside"
  );

// End Klaim CC Pp

// Begin Klaim CC PD
const KlaimCCPd = () =>
  import(/* webpackChunkName: "KlaimCCPd" */ "@/views/klaimCCPD/IndexKlaimCCPd");
const KlaimCCListPd = () =>
  import(
    /* webpackChunkName: "KlaimCCListPd" */ "@/views/klaimCCPD/ListKlaimCCPd"
  );
const KlaimCCManifestPd = () =>
  import(
    /* webpackChunkName: "KlaimCCManifestPd" */ "@/views/klaimCCPD/ManifestKlaimCCPd"
  );
const KlaimCCPdCreate = () =>
  import(
    /* webpackChunkName: "KlaimCCPdCreate" */ "@/views/klaimCCPD/CreateKlaimCCPd"
  );
const KlaimCCPuManifestPd = () =>
  import(
    /* webpackChunkName: "KlaimCCPuManifestPd" */ "@/views/klaimCCPD/ManifestOutside"
  );

const KlaimCCPDSpecial = () =>
  import(
    /* webpackChunkName: "KlaimCCPDSpecial" */ "@/views/specialMenu/klaimCcPd/specialDataList"
  );
// const KlaimCCPDBiayaPDPublicManifest = () =>
//   import(
//     /* webpackChunkName: "KlaimBiayaCCPDPublicManifest" */ "@/views/klaimCCPD/ManifestApproval"
//   );
// End Klaim CC PD

// Begin Bailout Fund
const BailoutFundRelease = () =>
  import(/* webpackChunkName: "BailoutFundRelease" */ "@/views/bailoutFund/BailoutFundRelease.vue");

const BailoutFund = () =>
  import(/* webpackChunkName: "BailoutFund" */ "@/views/bailoutFund/Bkk.vue");

const BailoutFundManifest = () =>
  import(/* webpackChunkName: "BailoutFundManifest" */ "@/views/bailoutFund/ManifestBKK");

const SpclBailoutFundList = () =>
  import(/* webpackChunkName: "SpclBailoutFundList" */ "@/views/bailoutFund/BailoutFundRelease.vue");
// End Bailout Fund

// Begin Bailout Fund Report
const BailoutFundReportIndex = () =>
  import(/* webpackChunkName: "BailoutFundReportIndex" */ "@/views/bailoutFundReport/Index.vue");
const BailoutFundReportList = () =>
  import(/* webpackChunkName: "BailoutFundReportList" */ "@/views/bailoutFundReport/List.vue");
const BailoutFundReportCreate = () =>
  import(/* webpackChunkName: "BailoutFundReportCreate" */ "@/views/bailoutFundReport/Create.vue");
const BailoutFundReportEdit = () =>
  import(/* webpackChunkName: "BailoutFundReportEdit" */ "@/views/bailoutFundReport/Create.vue");
const BailoutFundReportManifest = () =>
  import(/* webpackChunkName: "BailoutFundReportManifest" */ "@/views/bailoutFundReport/Manifest.vue");
const BailoutFundReportManifestPublic = () =>
  import(/* webpackChunkName: "BailoutFundReportManifestPublic" */ "@/views/bailoutFundReport/ManifestPublic.vue");
const SpclBailoutReportList = () =>
  import(/* webpackChunkName: "SpclBailoutReportList" */ "@/views/specialMenu/bailoutReport/specialDataList.vue");
// End Bailout Fund Report

// Start RNDNotification
const ProspectNotificationIndex = () =>
  import(
    /* webpackChunkName: "ProspectNotificationIndex" */ "@/views/prospectNotification/Index.vue"
  );
const ProspectNotification = () =>
  import(
    /* webpackChunkName: "ProspectNotification" */ "@/views/prospectNotification/List.vue"
  );
const ProspectNotificationManifest = () =>
  import(
    /* webpackChunkName: "ProspectNotificationManifest" */ "@/views/prospectNotification/Manifest.vue"
  );
const ProspectPublicNotificationManifest = () =>
  import(
    /* webpackChunkName: "ProspectPublicNotificationManifest" */ "@/views/prospectNotification/ManifestPublic.vue"
  );
const ProspectNotificationCreate = () =>
  import(
    /* webpackChunkName: "ProspectNotificationCreate" */ "@/views/prospectNotification/Create.vue"
  );
// End RNDNotification

// Start RekapKlaimKesehatan
const RekapKlaimKesehatanListIndex = () =>
  import(
    /* webpackChunkName: "RekapKlaimKesehatanListIndex" */ "@/views/rekapKlaimKesehatan/Index.vue"
  );
const RekapKlaimKesehatanList = () =>
  import(
    /* webpackChunkName: "RekapKlaimKesehatanList" */ "@/views/rekapKlaimKesehatan/List.vue"
  );
const RekapKlaimKesehatanManifest = () =>
  import(
    /* webpackChunkName: "RekapKlaimKesehatanManifest" */ "@/views/rekapKlaimKesehatan/Manifest.vue"
  );
// End RekapKlaimKesehatan

// Rekap Klaim Tiket
const RekapKlaimTiketListIndex = () =>
  import(
    /* webpackChunkName: "RekapKlaimTiketListIndex" */ "@/views/rekapKlaimTiket/Index.vue"
  );

const RekapKlaimTiketList = () =>
  import(
    /* webpackChunkName: "RekapKlaimTiketList" */ "@/views/rekapKlaimTiket/List.vue"
  );

const ManifestRekapKlaimTiket = () =>
  import(
    /* webpackChunkName: "RekapKlaimTiketList" */ "@/views/rekapKlaimTiket/Manifest.vue"
  );
// End

// Start RekapLKPD
const RekapLKPDListIndex = () =>
  import(
    /* webpackChunkName: "RekapLKPDListIndex" */ "@/views/rekapLKPD/Index.vue"
  );
const RekapLKPDList = () =>
  import(
    /* webpackChunkName: "RekapLKPDList" */ "@/views/rekapLKPD/List.vue"
  );
const RekapLKPDManifest = () =>
  import(
    /* webpackChunkName: "RekapLKPDManifest" */ "@/views/rekapLKPD/Manifest.vue"
  );
// End RekapLKPD

//Start Public
const ppDashBoard = () =>
  import(
    /* webpackChunkName: "ppDashBoard" */ "@/views/public/ppDashBoard.vue"
  );
//End Public

// Special Menu Kuasa Anggaran
const specialMenuBudget = () => 
  import(
    /* webpackChunkName: "specialMenuBudget" */ "@/views/specialMenu/budget/specialDataList.vue"
  );

const specialMenuBudgetCreate = () => 
  import(
    /* webpackChunkName: "specialMenuBudget" */ "@/views/specialMenu/budget/Create.vue"
  );

// Begin Credit Card
const CC = () => import(/* webpackChunkName: "CC" */ "@/views/cc/index.vue");
const CCBoard = () => import(/* webpackChunkName: "CCBoard" */ "@/views/cc/ccBoard.vue");
const CCReconciliation = () => import(/* webpackChunkName: "CCReconciliation" */ "@/views/cc/reconcile/index.vue");
const CCWrapper = () => import(/* webpackChunkName: "CCWrapper" */ "@/views/cc/reconcile/wrapper.vue");
const CCCreateReconciliation = () => import(/* webpackChunkName: "CCCreateReconciliation" */ "@/views/cc/reconcile/create.vue");
const CCManifestReconciliation  = () => import(/* webpackChunkName: "CCManifestReconciliation" */ "@/views/cc/reconcile/manifest.vue");
// End Credit Card

Vue.use(Router);

const isAuthenticated = (to, from, next) => {
  //jika url login yang terpanggil
  let url = to.path.split("/")
  if (to.name == "404" && url.length >= 5 && url[2] == "login") {
    if (localStorage.getItem("key_sim_infog") === null) {
      localStorage.setItem("key_sim_infog", url[4]);
    } else {
      localStorage.removeItem("key_sim_infog");
      localStorage.setItem("key_sim_infog", url[4]);
    }
  }

  if (to.meta.key === "66") {
    localStorage.setItem("nvky", to.meta.key);
  }

  let auth = "";
  try {
    let b64 = CryptoJS.enc.Base64.parse(localStorage.getItem("key_sim_infog"));
    let sVal = CryptoJS.enc.Utf8.stringify(b64);
    auth = JSON.parse(sVal);

    store.dispatch("SET_AUTH", auth);
    store.dispatch("FETCH_USER_ACCESS", auth.message.tlc);
    store.dispatch("SET_ISLOGIN", auth.status);
  } catch (e) {
    localStorage.removeItem("key_sim_infog");
    localStorage.removeItem("jd");
  }

  if (store.getters.getIsLogin && url[2] == "login") {
    next("/");
    return;
  }

  if (store.getters.getIsLogin) {
    next();
    return;
  }

  window.location = process.env.VUE_APP_PANDAPAKITA;
};

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      name: "404",
      component: P404,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/errorConnection",
      name: "noConnection",
      component: PNoCon,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/login/:string/:id",
      name: "LoginProcess",
      props: true,
      beforeEnter: (to, from, next) => {
        if (localStorage.getItem("key_sim_infog") === null) {
          localStorage.setItem("key_sim_infog", to.params.id);
        } else {
          localStorage.removeItem("key_sim_infog");
          localStorage.setItem("key_sim_infog", to.params.id);
        }

        next("/");
      },
    },
    {
      path: "/",
      name: "beranda",
      component: Beranda,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/sppd",
      component: Sppd,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "sppd",
          component: DataList,
        },
        {
          path: "create",
          name: "createSppd",
          component: SppdCreate,
        },
        {
          path: "edit/:id",
          name: "edit",
          props: true,
          component: SppdCreate,
        },
        {
          path: "manifest/:id",
          name: "manifest",
          props: true,
          component: SppdManifest,
        },
      ],
    },
    {
      path: "/umpd",
      component: UmPd,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "umpd",
          component: ListUmPd,
        },
        {
          path: "create",
          name: "umpdCreate",
          component: UmpdCreate,
        },
        {
          path: "edit/:id",
          name: "umpd_edit",
          props: true,
          component: UmpdCreate,
        },
        {
          path: "manifest/:id",
          name: "umpd_manifest",
          props: true,
          component: UmpdManifest,
        },
      ],
    },
    {
      path: "/purchasing",
      component: Purchasing,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "purchasing",
          component: PurchasingBoard,
        },
        {
          path: "supplier",
          name: "supplier",
          component: Supplier,
        },
        {
          path: "create",
          name: "createPurchasing",
          component: PurchasingCreate,
        },
        {
          path: "edit/:id",
          name: "editPurchasing",
          props: true,
          component: PurchasingCreate,
        },
        {
          path: "change/:id",
          name: "changePurchasing",
          props: true,
          component: PurchasingCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestPurchasing",
          props: true,
          component: PurchasingManifest,
        },
        {
          path: "SpclPPPurchase",
          name: "SpclPP_purchase",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifest_purchase",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPO",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifest_purchase",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabPurchasing",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestPurchasing",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "pppriority",
          name: "pppriority",
          component: SpclPriorityList_v2,
          props: true,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclAddendum",
          name: "SpclAddendum",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "manifestad/:id",
          name: "SpclAddendumManifestPurchasing",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOPurchasing",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestPurchasing",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "evaluasiSupplier",
          component: SupplierEvaluationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "supplierEvaluationPurchasing",
              props: true,
              component: SupplierEvaluation,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create/:id",
              name: "supplierEvaluation-createPurchasing",
              props: true,
              component: SupplierEvaluationCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: ":type/:id/",
              name: "supplierEvaluation-editPurchasing",
              props: true,
              component: SupplierEvaluationCreate,
            },
            {
              path: "manifest/:id",
              name: "supplierEvaluation-manifestPurchasing",
              props: true,
              component: SupplierEvaluationManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "refundPayment",
          component: RefundPaymentWrapper,
          children:
            [
              {
                path: "",
                name: "refundPayment",
                props: true,
                beforeEnter: isAuthenticated,
                component: RefundPayment
              },
              {
                path: "create",
                name: "createRefundPayment",
                props: true,
                beforeEnter: isAuthenticated,
                component: RefundPaymentCreate,
              },
              {
                path: "manifest/:id",
                name: "RefundPaymentManifestKeu",
                props: true,
                beforeEnter: isAuthenticated,
                component: ManifestRefundPayment,
              }
            ],
        },
        {
          path: "other-outcome",
          component: OtherOutcomeWrapper,
          children:
            [
              {
                path: "",
                name: "otheroutcomePurchasing",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherOutcome
              },
              {
                path: "create",
                name: "createOtherOutcomePurchasing",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherOutcomeCreate,
              },
              {
                path: "manifest/:id",
                name: "OtherOutcomeManifestPurchasing",
                props: true,
                beforeEnter: isAuthenticated,
                component: ManifestOtherOutcome,
              }
            ],
        },
      ],
    },
    {
      path: "/atasanLangsung",
      component: AtasanLangsung,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "atasanLangsung",
          component: AtasanLangsungBoard,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDAL",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestAL",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDAL",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestAL",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDAL",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestAL",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDAL",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestAL",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPAL",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestAL",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringpp",
          name: "SpclPPAL",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestAL",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPAL",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestAL",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOAL",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestAL",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOAL",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestAL",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPAL",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestAL",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdAL",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestAL",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "/laporanKegiatan/lapKegPD",
          component: LaporanPD,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "lapKegPdListAL",
              component: LaporanPDList,
            },
            {
              path: "create",
              name: "lapKegPdListCreateAL",
              component: LaporanPDListCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestLapPDAL",
              props: true,
              component: ManifestLapPD,
            },
            {
              path: "edit/:id",
              name: "lapKegPdEditAL",
              props: true,
              meta: {
                mode: "edit"
              },
              component: LaporanPDListCreate,
            },
            {
              path: "editdraft/:id",
              name: "lapKegPdEditDraftAL",
              props: true,
              meta: {
                isDraft: "edit"
              },
              component: LaporanPDListCreate,
            },
          ],
        },
        {
          path: "scplprio",
          name: "scplprioAL",
          component: spclQueueAL,
          props: true,
        },
        {
          path: "kaskecil",
          name: "kaskecil-atasanlangsung",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestAL",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotification",
              props: true,
              component: RNDNotification,
            },
            {
              path: "create",
              name: "createRNDNotification",
              props: true,
              component: RNDNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotification",
              props: true,
              component: RNDNotificationManifest,
            },
            {
              path: "edit/:id",
              name: "editRNDNotification",
              props: true,
              component: RNDNotificationCreate,
            },
          ]
        }
      ],
    },
    {
      path: "/pimpro",
      component: Pimpro,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "pimpro",
          component: PimproBoard,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDPimpro",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestPimpro",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDPimpro",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestPimpro",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDPimpro",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestPimpro",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDPimpro",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestPimpro",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringpp",
          name: "SpclPPPimpro",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestPimpro",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPPimpro",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestPimpro",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOPimpro",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestPimpro",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOPimpro",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestPimpro",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPPimpro",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestPimpro",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilPimpro",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestPimpro",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabPimpro",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestPimpro",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPD",
          name: "SpclLapKegPdPimpro",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestPimpro",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPPimpro",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestPimpro",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "addendum",
          name: "addendum-pimpro",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          }
        },
        {
          path: "addendum/manifest/:id",
          name: "SpclAddendumManifestPimpro",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "klaim-direktur",
          name: "Klaim-Direktur-Pimpro",
          component: SpclKlaimDirektur,
          props: true,
        },
        {
          path: "klaim-direktur/manifest/:id",
          name: "klaim-direktur-pimpro-manifest",
          component: DirekturKlaimManifest,
          props: true,
        },
        {
          path: "budget",
          name: "budget",
          component: specialMenuBudget,
          props: true,
          children: [
            
          ]
        },
        {
          path: "create-budget", //here
          name: "anggaranCreate",
          component: specialMenuBudgetCreate,
          props: true,
        },
        {
          path: "budget/manifest/:id&:rabview&:budget_thn",
          name: "budget-manifest",
          component: ManifestAnggaran,
          props: true,
        },
      ],
    },
    {
      path: "/direktur",
      component: Direktur,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "direktur",
          component: DirekturBoard,
        },
        {
          path: "monitoringpp",
          name: "SpclPPDir",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestDir",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDDir",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestDir",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPDir",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestDir",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDDir",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestDir",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPDir",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestDir",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDDir",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestDir",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclWO",
          name: "SpclWODir",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestDir",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPODir",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestDir",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilDir",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestDir",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplier",
          name: "SpclSupplierDir",
          component: Supplier,
          props: true,
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "SpclSupplierManifestDir",
          props: true,
          component: PurchasingManifest,
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabDir",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestDir",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesNotification",
          name: "SpclSalesNotificationDir",
          component: SpclSalesNotificationDataList,
          props: true,
        },
        {
          path: "SpclSalesNotificationManifest/:id",
          name: "SpclSalesNotificationManifestDir",
          props: true,
          component: SpclSalesNotificationManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDDir",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestDir",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdDir",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestDir",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPDir",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestDir",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyek",
          component: SpclProyekWrapperDirektur,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "spclProyek",
              props: true,
              component: SpclProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifestanggaran/:id&:rabview&:budget_thn",
              name: "spclManifestProyekDirektur",
              props: true,
              component: SpclManifestProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            }
          ],
        },
        {
          path: "scplprio",
          name: "scplprioDir",
          props: true,
          component: SpclPrio_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContractdir",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContractdir",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistorydir",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            {
              path: "create",
              name: "createSalesContract",
              component: SalesContractCreate,
            },
            {
              path: ":id/edit",
              name: "editSalesContract",
              props: true,
              component: SalesContractCreate,
            },
            {
              path: "edit/:type/:id",
              name: "editSalesContractByType",
              props: true,
              component: SalesContractCreate,
            },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexDir",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestDir",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafonDir",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafonDir",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifestDir",
          props: true,
          component: ManifestAnnualMonthly,
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationDir",
              props: true,
              component: RNDNotification,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationDir",
              props: true,
              component: RNDNotificationManifest,
            },
          ]
        },
        {
          path: "prospek",
          props: true,
          component: ProspectNotificationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "prospectNotificationDir",
              props: true,
              component: ProspectNotification,
            },
            {
              path: "create",
              name: "createProspectNotificationDir",
              props: true,
              component: ProspectNotificationCreate,
            },
            {
              path: "edit/:id",
              name: "editProspectNotificationDir",
              props: true,
              component: ProspectNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestProspectNotificationDir",
              props: true,
              component: ProspectNotificationManifest,
            },
          ]
        },
        {
          path: "salary-component",
          component: SalaryComponentIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "salary-component-list-dir",
              props: true,
              component: SalaryComponentList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "salary-component-create-dir",
              props: true,
              component: SalaryComponentCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:id",
              name: "salary-component-edit-dir",
              props: true,
              component: SalaryComponentCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "salary-component-manifest-dir",
              props: true,
              component: SalaryComponentManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
      ],
    },
    {
      path: "/directorate-delegation",
      component: DirectorDelegation,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "directorateDelegation",
          component: DirectorDelegationBoard,
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafonDirDel",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafonDirDel",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifestDirDel",
          props: true,
          component: ManifestAnnualMonthly,
        },
      ]
    },
    {
      path: "/opc",
      component: Opc,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "opc",
          component: OpcBoard,
        },
        {
          path: "scplprio",
          name: "scplprioOpc",
          props: true,
          component: SpclPrio_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "mon_pp",
          name: "mon_pp_opc",
          component: SpclPPDataListOPC,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestOPC",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafonOPC",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafonOPC",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifestOPC",
          props: true,
          component: ManifestAnnualMonthly,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDOPC",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestOPC",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
      ],
    },
    {
      path: "/hrd", //here HRD
      component: Hrd,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "Hrd",
          component: HrdBoard,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDHrd",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestHrd",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabHrd",
          component: SpclProyekRabDataList,
          props: true,
        },
        
        {
          path: "klaimtiket",
          name: "Spcl_Klaim_Cc_Tiket",
          component: SpclKlaimCCTiket,
          props: true,
        },
        {
          path: "SpclKlaimCCTiket/create",
          name: "create_klaim_tiket",
          component: SpclKlaimCCTiketCreate,
          props: true,
        },
        {
          path: "SpclKlaimCCTiket/edit/draft/:id",
          name: "edit_klaim_tiket",
          component: SpclKlaimCCTiketCreate,
          props: true,
        },
        {
          path: "SpclKlaimCCTiket/revise/:id",
          name: "revise_klaim_tiket",
          component: SpclKlaimCCTiketCreate,
          props: true,
        },
        {
          path: "SpclKlaimCCTiket/manifest/:id",
          name: "manifest_klaim_tiket",
          component: SpclKlaimCCTiketManifest,
          props: true,
        },

        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestHrd",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdHrd",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestHrd",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "piutangKaryawan",
          component: PiutangkaryawanIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "piutangkaryawan-list-hrd",
              props: true,
              meta: {
                ishrd: true,
              },
              component: PiutangkaryawanList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "piutangkaryawan-create-hrd",
              props: true,
              component: PiutangkaryawanCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:id",
              name: "piutangkaryawan-edit-hrd",
              props: true,
              component: PiutangkaryawanCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "piutangkaryawan-manifest-hrd",
              props: true,
              component: PiutangkaryawanManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
       { path: "pembayaranPiutang",
        component: PembayaranpiutangIndex,
        beforeEnter: isAuthenticated,
        children: [
          {
            path: "",
            name: "pembayaranpiutang-list-hrd",
            props: true,
            meta: {
              ishrd: true,
            },
            component: PembayaranpiutangList,
            beforeEnter: isAuthenticated,
          },
          {
            path: "create",
            name: "pembayaranpiutang-create-hrd",
            props: true,
            component: PembayaranpiutangCreate,
            beforeEnter: isAuthenticated,
          },
          {
            path: "edit/:id",
            name: "pembayaranpiutang-edit-hrd",
            props: true,
            component: PembayaranpiutangCreate,
            beforeEnter: isAuthenticated,
          },
          {
            path: "manifest/:id",
            name: "pembayaranpiutang-manifest-hrd",
            props: true,
            component: PembayaranpiutangManifest,
            beforeEnter: isAuthenticated,
          },
        ]
        },
        {
          path: "closing-um-ba",
          component: ClosingUMWrapperbyUploadBA,
          beforeEnter: isAuthenticated,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "closing-um-ba-index-hrd",
              props: true,
              component: ClosingUMbyUploadBA,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "/closingUMManifestBA/:id",
          name: "ClosingmanifestbyUploadBA-hrd",
          props: true,
          component: ClosingmanifestbyUploadBA,
        },
        {
          path: "rekap-klaim-kesehatan",
          component: RekapKlaimKesehatanListIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "rekapKlaimKesehatanList",
              props: true,
              component: RekapKlaimKesehatanList,
            },
            {
              path: "manifest/:id",
              name: "rekapKlaimKesehatanManifest",
              props: true,
              component: RekapKlaimKesehatanManifest,
            },
          ]
        },
        {
          path: "rekap-klaim-tiket",
          component: RekapKlaimTiketListIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "rekapKlaimTiketList",
              props: true,
              component: RekapKlaimTiketList,
            },
            {
              path: "manifest/:id",
              name: "rekapKlaimTiketManifest",
              props: true,
              component: ManifestRekapKlaimTiket,
            },
          ]
        },
        {
          path: "rekap-lkpd",
          component: RekapLKPDListIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "rekapLKPDList",
              props: true,
              component: RekapLKPDList,
            },
            {
              path: "manifest/:id",
              name: "rekapLKPDManifest",
              props: true,
              component: RekapLKPDManifest,
            },
          ]
        },
        {
          path: "salary-component",
          component: SalaryComponentIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "salary-component-list-hrd",
              props: true,
              meta: {
                ishrd: true,
              },
              component: SalaryComponentList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "salary-component-create-hrd",
              props: true,
              meta: {
                ishrd: true,
              },
              component: SalaryComponentCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:id",
              name: "salary-component-edit-hrd",
              props: true,
              meta: {
                ishrd: true,
              },
              component: SalaryComponentCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "salary-component-manifest-hrd",
              props: true,
              meta: {
                ishrd: true,
              },
              component: SalaryComponentManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "recapitulation-release",
          name: "RecapitulationRelease-hrd",
          component: RecapitulationRelease,
          beforeEnter: isAuthenticated,
          props: true,
          meta: {
            page_type: "recapitulation",
          },
        },
      ],
    },
    {
      path: "/cooperative",
      component: CooperativeIndex,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "Cooperative",
          component: CooperativeBoard,
        },
        {
          path: "cooperative-deduction",
          name: "",
          component: CooperativeDeductionWrapper,
          children: [
            {
              path: "",
              name: "CooperativeList",
              component: CooperativeDeduction,
            },
            {
              path: "create",
              name: "cooperativeDeductionCreate",
              component: CooperativeDeductionCreate,
            },
            {
              path: "edit/:id",
              name: "cooperativeDeductionEdit",
              props: true,
              component: CooperativeDeductionCreate,
            },
            {
              path: "manifest/:id",
              name: "cooperativeDeductionManifest",
              props: true,
              component: CooperativeDeductionManifest,
            },
          ]
        },
      ]
    },
    {
      path: "/cop",
      component: CopIndex,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "CopListIndex",
          component: CopWrapper,
        },
        {
          path: "payment-cop",
          name: "CopList",
          component: CopDeduction,
        },
        {
          path: "create",
          name: "copDeductionCreate",
          component: CopDeductionCreate,
        },
        {
          path: "edit/:id",
          name: "copDeductionEdit",
          props: true,
          component: CopDeductionCreate,
        },
        {
          path: "manifest/:id",
          name: "copDeductionManifest",
          props: true,
          component: CopDeductionManifest,
        },
      ]
    },
    {
      path: "/sitejakarta",
      component: SiteJakarta,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "sitejakarta",
          component: SiteJakartaBoard,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDJkt",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestJkt",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "LapKegPd",
          name: "SpclLapKegPdJkt",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestJkt",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
      ],
    },
    {
      path: "/ga",
      component: Ga,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "ga",
          component: GaBoard,
        },
        {
          path: "create",
          name: "createPurchasingGA",
          component: PurchasingCreate,
        },
        {
          path: "edit/:id",
          name: "editPurchasingGA",
          props: true,
          component: PurchasingCreate,
        },
        {
          path: "change/:id",
          name: "changePurchasingGA",
          props: true,
          component: PurchasingCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestPurchasingGA",
          props: true,
          component: PurchasingManifest,
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabGA",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestGA",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringpp",
          name: "SpclPPGA",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestGA",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPPGA",
          name: "SpclPP_ga",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifest_ga",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOGA",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestGA",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplier",
          name: "SpclSupplierGA",
          component: Supplier,
          props: true,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "SpclSupplierManifestGA",
          props: true,
          component: PurchasingManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "scplprio",
          name: "scplprio",
          props: true,
          component: SpclPrio_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclAddendum",
          name: "SpclAddendumGA",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "manifest/:id",
          name: "SpclAddendumManifestGA",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOGA",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestGA",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "evaluasiSupplier",
          component: SupplierEvaluationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "supplierEvaluationGA",
              props: true,
              component: SupplierEvaluation,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "supplierEvaluation-createGA",
              props: true,
              component: SupplierEvaluationCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: ":type/:id/",
              name: "supplierEvaluation-editGA",
              props: true,
              component: SupplierEvaluationCreate,
            },
            {
              path: "manifest/:id",
              name: "supplierEvaluation-manifestGA",
              props: true,
              component: SupplierEvaluationManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPGA",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestGA",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
      ],
    },
    {
      path: "/verifikatorPelaporan",
      component: VerifikatorPelaporan,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "verifikatorPelaporan",
          component: VerifikatorPelaporanBoard,
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPVP",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestVP",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDVP",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestVP",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDVP",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestVP",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },

        { //here
          path: "SpclMenuMonKlaimCCPP",
          name: "SpclMenuMonKlaimCCPPVP",
          component: SpclKlaimCCPP,
          props: true,
        },
        {
          path: "SpclMenuMonKlaimCCPPManifest/:id",
          name: "SpclMenuMonKlaimCCPPManifestVP",
          props: true,
          component: KlaimManifestCCPp,
          meta: {
            isSpecialMenu: true,
          },
        },

        {//here
          path: "SpclMenuMonKlaimCCPD",
          name: "SpclMenuMonKlaimCCPDVP",
          component: KlaimCCPDSpecial,
          props: true,
        },
        {
          path: "SpclMenuMonKlaimCCPDManifest/:id",
          name: "SpclMenuMonKlaimCCPDManifestVP",
          props: true,
          component: KlaimCCManifestPd,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilVP",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclMenuMonKlaimCc",
          name: "SpclKlaimCcVP",
          component: SpclKlaimCc,
          props: true,
        },
        {
          path: "SpclKlaimCcManifest/:id",
          name: "SpclKlaimCcManifestVP",
          props: true,
          component: KlaimCCManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestVP",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonKlaimDir",
          name: "verifikator-klaim-direktur",
          props: true,
          component: SpclKlaimDirektur,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonKlaimPP",
          name: "verifikator-klaim-pp",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclManifestKlaimDirektur/:id",
          name: "SpclKlaimDirekturManifestVer",
          component: DirekturKlaimManifest,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestVer",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoring/bailoutReport",
          name: "SpecialBailoutReportVer",
          meta: {
            spcl_menu_monitoring:true,
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutReportList,
        },
        {
          path: "monitoring/manifestBailoutReport/:id",
          name: "SpecialManifestBailoutReportVer",
          props: true,
          beforeEnter: isAuthenticated,
          component: BailoutFundReportManifest,
        },
        {
          path: "monitoring/bailoutFund",
          name: "SpecialBailoutFundVer",
          meta: {
            spcl_menu_monitoring:true,
            page_type: "monitoring bailoutfund",
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutFundList,
        },
      ],
    },
    {
      path: "/pp",
      component: PP,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "pp",
          component: PPBoard,
        },
        {
          path: "create",
          name: "createPP",
          component: PPCreate,
        },
        {
          path: "edit/:id",
          name: "editPp",
          props: true,
          component: PPCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestPp",
          props: true,
          component: PPManifest,
        },
        {
          path: "umpp",
          name: "ListUmPp",
          props: true,
          component: ListUmPp,
        },
        {
          path: "umpp/create",
          name: "UmppCreate",
          props: true,
          component: UmppCreate,
        },
        {
          path: "umpp/manifest/:id",
          name: "UmppManifest",
          props: true,
          component: UmppManifest,
        },
        {
          path: "umpp/edit/:id",
          name: "UmppEdit",
          props: true,
          component: UmppCreate,
        },
      ],
    },
    {
      path: "/addendum",
      component: Addendum,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "listAddendum",
          component: ListAddendum,
        },
        {
          path: "create",
          name: "createAddendumGeneral",
          props: true,
          meta: {
            process: "create",
          },
          component: AddendumCreate,
        },
        {
          path: "create/:id/:jenis_transaksi",
          name: "createAddendum",
          props: true,
          meta: {
            process: "create",
          },
          component: AddendumCreate,
        },
        {
          path: "edit/:jenis_transaksi/:id",
          name: "editAddendum",
          props: true,
          meta: {
            process: "edit",
          },
          component: AddendumCreate,
        },
        {
          path: "manifest/:id",
          name: "AddendumManifest",
          props: true,
          component: ManifestAddendum,
        },
      ],
    },
    {
      path: "/logout",
      name: "logout",
      component: LogoutProcess,
      props: true,
    },
    {
      path: "/app",
      name: "app",
      props: true,
      beforeEnter: () => {
        localStorage.removeItem("key_sim_infog");
        localStorage.removeItem("jd");
        window.location = process.env.VUE_APP_PANDAPAKITA;
      },
    },
    {
      path: "/laporan/umpp",
      component: LaporanUMPP,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "laporanUmpp",
          component: LaporanList,
        },
        {
          path: "create",
          name: "lapUmppCreate",
          props: true,
          component: LaporanUmppCreate,
        },
        {
          path: "edit/:type/:id",
          name: "lapDraftUmppEdit",
          props: true,
          component: LaporanUmppCreate,
        },
        {
          path: "edit/:type/:id",
          name: "lapUmppEdit",
          props: true,
          component: LaporanUmppCreate,
        },
        {
          path: "manifest/:id",
          name: "lapUmppManifest",
          props: true,
          component: LaporanUmppManifest,
        },
      ],
    },
    {
      path: "/laporan/lapkegiatanpd",
      component: LaporanPD,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "lapKegPdList",
          component: LaporanPDList,
        },
        {
          path: "create",
          name: "lapKegPdListCreate",
          component: LaporanPDListCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestLapPD",
          props: true,
          component: ManifestLapPD,
        },
        {
          path: "edit/:id",
          name: "lapKegPdEdit",
          props: true,
          meta: {
            mode: "edit"
          },
          component: LaporanPDListCreate,
        },
        {
          path: "editdraft/:id",
          name: "lapKegPdEditDraft",
          props: true,
          meta: {
            isDraft: "edit"
          },
          component: LaporanPDListCreate,
        },
      ],
    },
    {
      path: "/po",
      component: PO,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "po",
          component: ListPO,
        },
        {
          path: "manifest/:id",
          name: "PoManifest",
          props: true,
          component: PoManifest,
        },
        {
          path: "create",
          name: "createPo",
          props: true,
          component: CreatePo,
        },
        {
          path: "edit/:id",
          name: "editPo",
          props: true,
          component: CreatePo,
        },
        {
          path: "draft/:id",
          name: "draftPo",
          props: true,
          meta: {
            isDraftEdited: true,
          },
          component: CreatePo,
        },
      ],
    },
    {
      path: "/wo",
      component: WO,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "wo",
          component: WOBoard,
        },
        {
          path: "create",
          name: "createWO",
          component: WOCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestWO",
          props: true,
          component: WOManifest,
        },
        {
          path: "edit/:id",
          name: "editWO",
          props: true,
          component: WOCreate,
        },
      ],
    },
    // {
    //   path: "/simulasi",
    //   name: "simulasianggaranAcc",
    //   component: SimulasiAnggaran,
    //   props: true,
    //   redirect: {
    //     name: "simulasianggaran.listingAcc",
    //   },
    //   children: [
    //     {
    //       path: "",
    //       name: "simulasianggaran.listingAcc",
    //       props: true,
    //       component: SimulasiAnggaranList,
    //     },
    //     {
    //       path: "create",
    //       name: "simulasianggaranCreateAcc",
    //       props: true,
    //       component: CreateSimulasiAnggaran,
    //     },
    //     {
    //       path: "edit/:id&:thn",
    //       name: "simulasianggaranEditAcc",
    //       props: true,
    //       component: CreateSimulasiAnggaran,
    //     },
    //   ],
    // },
    {
      path: "/keuangan",
      component: Keuangan,
      beforeEnter: isAuthenticated,
      meta: ["keuangan"],
      children: [
        {
          path: "",
          name: "keuangan",
          props: true,
          component: KeuanganDashboard,
        },
        {
          path: "proyekrab",
          name: "proyekrab",
          component: ProyekRab,
          props: true,
          redirect: {
            name: "proyekrab.listing",
          },
          children: [
            {
              path: "",
              name: "proyekrab.listing",
              props: true,
              component: ListProyekRab,
            },
            {
              path: "manifestrab/:id&:rabview",
              name: "proyekrab.manifestrab",
              props: true,
              component: ManifestRab,
            },
            {
              path: "create",
              name: "proyekrabCreate",
              props: true,
              component: CreateProyekRab,
            },
            {
              path: "edit/:id",
              name: "proyekrabEdit",
              props: true,
              component: CreateProyekRab,
            },
            {
              path: "update/:id&:complete",
              name: "project-update",
              props: true,
              component: CreateProyekRab,
            },
          ],
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDKeu",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestKeu",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDKeu",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestKeu",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDKeu",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestKeu",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDKeu",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestKeu",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },

        {//here
          path: "SpclMenuMonKlaimCCPD",
          name: "SpclMenuMonKlaimCCPDKeu",
          component: KlaimCCPDSpecial,
          props: true,
        },
        {
          path: "SpclMenuMonKlaimCCPDManifest/:id",
          name: "SpclMenuMonKlaimCCPDManifestKeu",
          props: true,
          component: KlaimCCManifestPd,
          meta: {
            isSpecialMenu: true,
          },
        },

        {
          path: "monitoringpp",
          name: "SpclPPKeu",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestKeu",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPKeu",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestKeu",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOKeu",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestKeu",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOKeu",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestKeu",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPKeu",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestKeu",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabKeu",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestKeu",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesNotification",
          name: "SpclSalesNotificationKeu",
          component: SpclSalesNotificationDataList,
          props: true,
        },
        {
          path: "SpclSalesNotificationManifest/:id",
          name: "SpclSalesNotificationManifestKeu",
          props: true,
          component: SpclSalesNotificationManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesContractKeu",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContractKeu",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContractKeu",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistoryKeu",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            {
              path: "create",
              name: "createSalesContractKeu",
              component: SalesContractCreate,
            },
            {
              path: ":id/edit",
              name: "editSalesContractKeu",
              props: true,
              component: SalesContractCreate,
            },
            {
              path: "edit/:type/:id",
              name: "editSalesContractByTypeKeu",
              props: true,
              component: SalesContractCreate,
            },
          ]
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilKeu",
          component: SpclKasKecilDataList,
          props: true,
          meta: {
            isMonitoring: true,
          },
        },
        {
          path: "manifest/:id",
          name: "manifestLaporanKasKecilKeu",
          props: true,
          component: LaporanManifestKasKecil,
        },
        {
          path: "bkk",
          name: "BkkKeu",
          component: Bkk,
          props: true,
          meta: {
            page_type: "ukk",
          },
        },
        {
          path: "bkkManifest/:id",
          name: "bkkManifestKeu",
          props: true,
          component: BkkManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "PIRelease",
          name: "PIRelease",
          component: PIRelease,
          props: true,
          meta: {
            page_type: "pi",
          },
        },
        {
          path: "/pirelease/Edit/:idrilisedit",
          name: "PIReleaseEdit",
          props: true,
          meta: {
            page_type: "pi",
          },
          beforeEnter: isAuthenticated,
          component: PIRelease,
        },
        {
          path: "ManifestPIRelease/:id",
          name: "ManifestPIRelease",
          component: ManifestPIRelease,
          props: true,
        },
        {
          path: "recapitulation-release",
          name: "RecapitulationRelease",
          component: RecapitulationRelease,
          beforeEnter: isAuthenticated,
          props: true,
          meta: {
            page_type: "recapitulation",
            onlyView: "true"
          },
        },
        {
          path: "/recapitulation-release/Edit/:idrilisedit",
          name: "RecapitulationReleaseEdit",
          props: true,
          meta: {
            page_type: "recapitulation",
          },
          beforeEnter: isAuthenticated,
          component: RecapitulationRelease,
        },
        {
          path: "manifest-recapitulation-release/:id",
          name: "ManifestRecapitulationRelease",
          component: ManifestRecapitulationRelease,
          props: true,
        },
        {
          path: "BkkReleasePI",
          name: "BkkReleasePI",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "pi",
          },
        },
        {
          path: "BkkReleaseUmpp",
          name: "BkkReleaseUmpp",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "umpp",
          },
        },
        {
          path: "BkkReleaseUmpd",
          name: "BkkReleaseUmpd",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "umpd",
          },
        },
        {
          path: "BkkReleaseKlaimpd",
          name: "BkkRelease",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaimpd",
          },
        },
        {
          path: "BkkReleaseKlaimpp",
          name: "BkkReleaseKlaimPP",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaimpp",
          },
        },
        {
          path: "BkkReleaseKlaimdirektur",
          name: "BkkReleaseKlaimdirektur",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaimdirektur",
          },
        },
        {
          path: "BkkReleaseKlaimCC",
          name: "BkkReleaseKlaimCC",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaim_cc",
            page_title: "Credit Card Claim"
          },
        },
        {
          path: "BkkReleaseKlaimCCPP",
          name: "BkkReleaseKlaimCCPP",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaim_cc_pp",
            page_title: "Credit Card PP Claim"
          },
        },
        {
          path: "BkkReleaseKlaimCCPD",
          name: "BkkReleaseKlaimCCPD",
          component: BkkRelease,
          props: true,
          meta: {
            page_type: "klaim_cc_pd",
            page_title: "Credit Card PD Claim"
          },
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestKeu",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplier",
          name: "SpclSupplierKeu",
          component: Supplier,
          props: true,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "SpclSupplierManifestKeu",
          props: true,
          component: PurchasingManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPD",
          name: "SpcllapKegPDKeu",
          props: true,
          component: SpclLapKegPdDataList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestKeu",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "/simulasi",
          name: "simulasianggaranAcc",
          component: SimulasiAnggaran,
          props: true,
          redirect: {
            name: "simulasianggaran.listingAcc",
          },
          children: [
            {
              path: "",
              name: "simulasianggaran.listingAcc",
              props: true,
              component: SimulasiAnggaranList,
            },
            {
              path: "create",
              name: "simulasianggaranCreateAcc",
              props: true,
              component: CreateSimulasiAnggaran,
            },
            {
              path: "edit/:id&:thn",
              name: "simulasianggaranEditAcc",
              props: true,
              component: CreateSimulasiAnggaran,
            },
            {
              path: "manifestsimulasianggaran/:id&:thn",
              name: "simulasianggaran.manifestAcc",
              props: true,
              component: ManifestSimulasiAnggaran,
            },
          ],
        },
        {
          path: "SpclPI",
          name: "SpclPIKeu",
          props: true,
          component: SpclPIDataList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPiManifest/:id",
          name: "SpclPiManifestKeu",
          props: true,
          component: PiManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "pppriority",
          name: "priorityGa",
          props: true,
          component: GaPriority_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "priopurchasing",
          name: "priopurchasing",
          props: true,
          component: PrioPurchasing_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "account-pay",
          component: AccountPayWrapper,
          children: [
            {
              path: "",
              name: "account-pay-index",
              props: true,
              component: AccountPayIndex,
            },
            {
              path: "manifest/:id",
              name: "account-pay-manifest",
              props: true,
              component: AccountPayManifest,
            }
          ]
        },
        {
          path: "SpclAddendum",
          name: "SpclAddendumkeu",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "manifest/:id",
          name: "SpclAddendumManifestKeu",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPKeu",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestKeu",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },

        { //here
          path: "SpclKlaimCCPP",
          name: "SpclMenuMonKlaimCCPPKeu",
          component: SpclKlaimCCPP,
          props: true,
        },
        {
          path: "SpclKlaimCCPPManifest/:id",
          name: "SpclKlaimCCPPManifestKeu",
          props: true,
          component: KlaimManifestCCPp,
          meta: {
            isSpecialMenu: true,
          },
        },

        {
          path: "SpclKlaimDirektur",
          name: "Spcl_Klaim_DirekturKeu",
          component: SpclKlaimDirektur,
          props: true,
        },
        {
          path: "SpclManifestKlaimDirektur/:id",
          name: "SpclKlaimDirekturManifestKeu",
          component: DirekturKlaimManifest,
          props: true,
        },
        {
          path: "SpclKlaimCC",
          name: "Spcl_Klaim_Cc",
          component: SpclKlaimCc,
          props: true,
        },
        { //here
          path: "SpclKlaimCCTiket",
          name: "Spcl_Klaim_Cc_Tiket_monitoring",
          component: SpclKlaimCCTiket,
          props: true,
        },
        // {
        //   path: "SpclKlaimCCTiket/create",
        //   name: "create_klaim_tiket",
        //   component: SpclKlaimCCTiketCreate,
        //   props: true,
        // },
        // {
        //   path: "SpclKlaimCCTiket/edit/draft/:id",
        //   name: "edit_klaim_tiket",
        //   component: SpclKlaimCCTiketCreate,
        //   props: true,
        // },
        // {
        //   path: "SpclKlaimCCTiket/revise/:id",
        //   name: "revise_klaim_tiket",
        //   component: SpclKlaimCCTiketCreate,
        //   props: true,
        // },
        {
          path: "SpclKlaimCCTiket/manifest/:id",
          name: "manifest_klaim_tiket_monitoring",
          component: SpclKlaimCCTiketManifest,
          props: true,
        },
        {
          path: "SpclManifestKlaimCC/:id",
          name: "Spcl_Klaim_Manifest_Cc",
          component: KlaimCCManifest,
          props: true,
        },
        {
          path: "AccMutation",
          name: "AccountMutationIndexKeu",
          component: AccountMutationIndex,
          props: true,
          redirect: {
            name: "AccountMutationKeu",
          },
          children: [
            {
              path: "List",
              name: "AccountMutationKeu",
              props: true,
              component: AccountMutationList,
            },
            {
              path: "create",
              name: "AccountMutationCreateKeu",
              props: true,
              component: AccountMutationCreate,
            },
            {
              path: "manifestAM/:id",
              name: "AccountMutationManifestKeu",
              props: true,
              component: ManifestAccountMutation,
            },
          ]
        },
        {
          path: "other-income",
          component: OtherIncomeWrapper,
          children:
            [
              {
                path: "",
                name: "otherincome",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherIncome
              },
              {
                path: "create",
                name: "createOtherIncome",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherIncomeCreate,
              },
              {
                path: "manifest/:id",
                name: "OtherIncomeManifestKeu",
                props: true,
                beforeEnter: isAuthenticated,
                component: ManifestOtherIncome,
              }
            ],
        },
        {
          path: "other-outcome",
          component: OtherOutcomeWrapper,
          children:
            [
              {
                path: "",
                name: "otheroutcome",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherOutcome
              },
              {
                path: "create",
                name: "createOtherOutcome",
                props: true,
                beforeEnter: isAuthenticated,
                component: OtherOutcomeCreate,
              },
              {
                path: "manifest/:id",
                name: "OtherOutcomeManifestKeu",
                props: true,
                beforeEnter: isAuthenticated,
                component: ManifestOtherOutcome,
              }
            ],
        },
        {
          path: "payment-schedule",
          component: PaymentScheduleWrapper,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "spcl.payment.schedule.index",
              props: true,
              component: PaymentScheduleIndex,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "PaymentScheduleManifest/:id",
          name: "PaymentScheduleManifestKeu",
          props: true,
          beforeEnter: isAuthenticated,
          component: ManifestPaymentSchedule,
        },
        {
          path: "bkm",
          component: BKMWrapper,
          children: [
            {
              path: "",
              name: "bkm",
              props: true,
              component: BKMIndex,
            },
            {
              path: "bkmManifest/:id",
              name: "bkmManifestKeu",
              props: true,
              component: BkmManifest,
              meta: {
                isSpecialMenu: true,
              },
            },
          ]
        },
        {
          path: "accReceive",
          component: AccountReceiveWrapper,
          children: [
            {
              path: "",
              name: "account-receive-index",
              props: true,
              component: AccountReceiveIndex,
            },
            {
              path: "manifest/:tab/:jns/:id",
              name: "account-receive-manifest",
              props: true,
              component: AccountReceiveManifest,
            },
            {
              path: "creategeneral",
              name: "creategeneral-account-receive",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveCreateGeneral,
            },
            {
              path: "createNgeneral/:id",
              name: "createNgeneral-account-receive",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveCreateNGeneral,
            },
            {
              path: "editNgeneral/:id",
              name: "editNgeneral-account-receive",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveEditNGeneral,
            },
          ]
        },
        {
          path: "financing",
          component: FinancingIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "financing-list",
              props: true,
              component: FinancingList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "financing-create",
              props: true,
              component: FinancingCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "financing-edit",
              props: true,
              component: FinancingCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "financing-manifest",
              props: true,
              component: ManifestFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: ":id/:tlc_pembuat/manifest",
          name: "manifestSalesContract",
          props: true,
          component: SalesContractManifest,
        },
        {
          path: "penarikan-financing-kmk",
          component: PenarikanFinancingIndex,
          children: [
            {
              path: "",
              name: "penarikan-financing-list",
              props: true,
              beforeEnter: isAuthenticated,
              component: PenarikanFinancingList,
            },
            {
              path: "create",
              name: "penarikan-financing-create",
              props: true,
              beforeEnter: isAuthenticated,
              component: PenarikanFinancingCreate,
            },
            {
              path: "edit/:id",
              name: "penarikan-financing-edit",
              props: true,
              beforeEnter: isAuthenticated,
              component: PenarikanFinancingCreate,
            },
            {
              path: "manifest/:id",
              name: "penarikan-financing-manifest",
              props: true,
              beforeEnter: isAuthenticated,
              component: PenarikanFinancingManifest,
            },
          ],
        },
        {
          path: "bank-account",
          component: BankAccountIndex,
          children: [
            {
              path: "",
              name: "bank-account-list",
              props: true,
              beforeEnter: isAuthenticated,
              component: BankAccountList,
            },
            {
              path: "create",
              name: "bank-account-create",
              props: true,
              beforeEnter: isAuthenticated,
              component: BankAccountCreate,
            },
            {
              path: ":id/edit",
              name: "bank-account-edit",
              props: true,
              beforeEnter: isAuthenticated,
              component: BankAccountEdit,
            },
          ],
        },
        {
          path: "bankguarantee",
          component: BankGuaranteeWrapper,
          children: [
            {
              path: "",
              name: "bankguarantee-index",
              props: true,
              component: BankGuaranteeIndex,
            },
            {
              path: "create/:props_invoice_no",
              name: "bankguarantee-create",
              props: true,
              component: BankGuaranteeIndex,
            },
            {
              path: "manifest/:id",
              name: "bankguarantee-manifest",
              props: true,
              component: BankGuaranteeManifest,
            }
          ]
        },
        {
          path: "cashonhandbank",
          component: CashOnHandWrapper,
          children: [
            {
              path: "",
              name: "cashonhand-index-keu",
              props: true,
              component: CashOnHandIndex,
            },
            {
              path: "manifest/:id&:pages",
              name: "cashonhand-manifest-keu",
              props: true,
              component: CashOnHandManifest,
            }
          ]
        },
        {
          path: "bidBondRequest",
          component: BidBondRequestIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBondRequest-listKeu",
              props: true,
              meta: {
                ismarketing: false,
              },
              component: BidBondRequestList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBondRequest-createKeu",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBondRequest-editKeu",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBondRequest-manifestKeu",
              props: true,
              component: BidBondRequestFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "bidBond",
          component: BidBondIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBond-listKeu",
              props: true,
              meta: {
                ismarketing: false,
              },
              component: BidBondList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBond-createKeu",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBond-editKeu",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBond-manifestKeu",
              props: true,
              component: BidBondFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "piutangKaryawan",
          component: PiutangkaryawanIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "piutangkaryawan-list-keu",
              props: true,
              meta: {
                ishrd: false,
              },
              component: PiutangkaryawanList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "piutangkaryawan-create-keu",
              props: true,
              component: PiutangkaryawanCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:id",
              name: "piutangkaryawan-edit-keu",
              props: true,
              component: PiutangkaryawanCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "piutangkaryawan-manifest-keu",
              props: true,
              component: PiutangkaryawanManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "pembayaranPiutang",
          component: PembayaranpiutangIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "pembayaranpiutang-list-keu",
              props: true,
              meta: {
                ishrd: false,
              },
              component: PembayaranpiutangList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "pembayaranpiutang-create-keu",
              props: true,
              component: PembayaranpiutangCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:id",
              name: "pembayaranpiutang-edit-keu",
              props: true,
              component: PembayaranpiutangCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "pembayaranpiutang-manifest-keu",
              props: true,
              component: PembayaranpiutangManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "TerminRelease",
          component: TerminReleaseIndex,
          children: [
            {
              path: "",
              name: "terminRelease-ListKeu",
              props: true,
              component: TerminReleaseList,
            },
            {
              path: "create",
              name: "terminReleaseCreateKeu",
              component: TerminReleaseCreate,
            },
            {
              path: "edit/:id",
              name: "terminReleaseEditKeu",
              props: true,
              component: TerminReleaseCreate,
            },
            {
              path: "manifest/:id",
              name: "terminReleaseManifestKeu",
              props: true,
              component: TerminReleaseManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "closing-um",
          component: ClosingUMWrapper,
          beforeEnter: isAuthenticated,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "closing-um-index",
              props: true,
              component: ClosingUM,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "/closingUMManifest/:id",
          name: "closingUMManifestKeu",
          props: true,
          component: Closingmanifest,
        },
        {
          path: "closing-um-ba",
          component: ClosingUMWrapperbyUploadBA,
          beforeEnter: isAuthenticated,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "closing-um-ba-index",
              props: true,
              component: ClosingUMbyUploadBA,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "/closingUMManifestBA/:id",
          name: "ClosingmanifestbyUploadBA",
          props: true,
          component: ClosingmanifestbyUploadBA,
        },
        {
          path: "invoice",
          component: InvoiceWrapper,
          children: [
            {
              path: "",
              name: "invoice-index",
              props: true,
              component: InvoiceIndex,
            },
            {
              path: "create-ap",
              name: "invoice-general-create-AP",
              props: true, 
              meta: {
                type_invoice: "0",
              },
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "create-ad",
              name: "invoice-general-create-AD",
              meta: {
                type_invoice: "1",
              },
              props: true,
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "create-ap/:type/:id",
              name: "invoice-create-ap",
              props: true,
              meta: {
                type_invoice: "0",
              },
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "create-ad/:type/:id",
              name: "invoice-create-ad",
              props: true,
              meta: {
                type_invoice: "1",
              },
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "edit-ap/:type/:id",
              name: "invoice-edit-ap",
              props: true,
              meta: {
                type_invoice: "0",
              },
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "edit-ad/:type/:id",
              name: "invoice-edit-ad",
              props: true,
              meta: {
                type_invoice: "1",
              },
              beforeEnter: isAuthenticated,
              component: InvoiceCreate,
            },
            {
              path: "manifest/:id",
              name: "invoice-manifest",
              props: true,
              component: InvoiceManifest,
            }
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexKeu",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestKeu",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "SpclProyek",
          component: SpclProyekWrapperDirektur,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "spclProyekKeu",
              props: true,
              component: SpclProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifestanggaran/:id&:rabview&:budget_thn",
              name: "spclManifestProyekKeu",
              props: true,
              component: SpclManifestProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            }
          ],
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationKeu",
              props: true,
              component: RNDNotification,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationKeu",
              props: true,
              component: RNDNotificationManifest,
            },
          ]
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafonKeu",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafonKeu",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifestKeu",
          props: true,
          component: ManifestAnnualMonthly,
        },
        {
          path: "creditcard",
          component: CreditCardWrapper,
          children: [
            {
              path: "",
              name: "creditcard-index",
              props: true,
              component: CreditCardIndex,
            },
            {
              path: "create/:props_invoice_no",
              name: "creditcard-create",
              props: true,
              component: CreditCardIndex,
            },
            {
              path: "manifest/:id",
              name: "creditcard-manifest",
              props: true,
              component: CreditCardManifest,
            }
          ]
        },
        {
          path: "monitoring/bailoutReport",
          name: "SpecialBailoutReport",
          beforeEnter: isAuthenticated,
          component: SpclBailoutReportList,
        },
        {
          path: "monitoring/manifestBailoutReport/:id",
          name: "SpecialManifestBailoutReport",
          props: true,
          beforeEnter: isAuthenticated,
          component: BailoutFundReportManifest,
        },
        {
          path: "monitoring/bailoutFund",
          name: "SpecialBailoutFund",
          meta: {
            spcl_menu_monitoring:true,
            page_type: "monitoring bailoutfund",
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutFundList,
        },
      ],
    },
    {
      path: "/akuntansiKeuangan",
      component: AkuntansiKeuangan,
      beforeEnter: isAuthenticated,
      meta: ["akuntansiKeuangan"],
      children: [
        {
          path: "",
          name: "akuntansiKeuangan",
          props: true,
          component: AkuntansiKeuanganDashboard,
        },
        {
          path: "proyekrab",
          name: "proyekrabAcc",
          component: ProyekRab,
          props: true,
          redirect: {
            name: "proyekrab.listingAcc",
          },
          children: [
            {
              path: "",
              name: "proyekrab.listingAcc",
              props: true,
              component: ListProyekRab,
            },
            {
              path: "manifestrab/:id&:rabview",
              name: "proyekrab.manifestrabAcc",
              props: true,
              component: ManifestRab,
            },
            {
              path: "create",
              name: "proyekrabCreateAcc",
              props: true,
              component: CreateProyekRab,
            },
            {
              path: "edit/:id",
              name: "proyekrabEditAcc",
              props: true,
              component: CreateProyekRab,
            },
          ],
        },
        {
          path: "SpclAnggaran",
          name: "anggaranAcc",
          component: Anggaran,
          props: true,
          redirect: {
            name: "anggaran.listingAcc",
          },
          children: [
            {
              path: "",
              name: "anggaran.listingAcc",
              props: true,
              component: AnggaranList,
            },
            {
              path: "create",
              name: "anggaranCreateAcc",
              props: true,
              component: CreateAnggaran,
            },
            {
              path: "edit/:id",
              name: "anggaranEditAcc",
              props: true,
              component: CreateAnggaran,
            },
          ],
        },
        {
          path: "/manifestanggaran/:id&:rabview&:budget_thn&:status",
          name: "anggaran.manifestAcc",
          props: true,
          component: ManifestAnggaran,
        },
        {
          path: "/manifestanggaran/draft/:id",
          name: "anggaran.manifest.draft",
          props: true,
          component: ManifestAnggaranDraft,
        },
        {
          path: "/manifestanggaran/history/:id",
          name: "anggaran.manifest.history",
          props: true,
          component: ManifestAnggaranHistory,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDAcc",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestAcc",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDAcc",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestAcc",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDAcc",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestAcc",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDAcc",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestAcc",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringpp",
          name: "SpclPPAcc",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestAcc",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPAcc",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestAcc",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOAcc",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestAcc",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclWO",
          name: "SpclWOAcc",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestAcc",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPAcc",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestAcc",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabAcc",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestAcc",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesNotification",
          name: "SpclSalesNotificationAcc",
          component: SpclSalesNotificationDataList,
          props: true,
        },
        {
          path: "SpclSalesNotificationManifest/:id",
          name: "SpclSalesNotificationManifestAcc",
          props: true,
          component: SpclSalesNotificationManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilAcc",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestAcc",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplier",
          name: "SpclSupplierAcc",
          component: SpclSupplier,
          props: true,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "SpclSupplierManifestAcc",
          props: true,
          component: PurchasingManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPD",
          name: "SpcllapKegPDAcc",
          props: true,
          component: SpclLapKegPdDataList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestAcc",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPAcc",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestAcc",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "account_pay",
          component: AccountPayWrapper,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "Spclaccount-pay-index",
              props: true,
              component: AccountPayIndex,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifest/:id",
              name: "Spclaccount-pay-manifest",
              props: true,
              component: AccountPayManifest,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "bkkManifest/:id",
          name: "bkkManifestAcc",
          props: true,
          component: BkkManifestAcc,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "BkkReleasePI",
          name: "BkkReleasePIAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "pi",
          },
        },
        {
          path: "BkkReleaseUmpp",
          name: "BkkReleaseUmppAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "umpp",
          },
        },
        {
          path: "BkkReleaseUmpd",
          name: "BkkReleaseUmpdAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "umpd",
          },
        },
        {
          path: "BkkReleaseKlaimpd",
          name: "BkkReleaseKlaimpdAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaimpd",
          },
        },
        {
          path: "BkkReleaseKlaimpp",
          name: "BkkReleaseKlaimPPAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaimpp",
          },
        },
        {
          path: "BkkReleaseKlaimdirektur",
          name: "BkkReleaseKlaimdirekturAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaimdirektur",
          },
        },
        {
          path: "BkkReleaseKlaimCC",
          name: "BkkReleaseKlaimCCAcc",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaim_cc",
            page_title: "Credit Card Claim Director"
          },
        },
        {
          path: "SpclKlaimDirektur",
          name: "Spcl_Klaim_DirekturAcc",
          component: SpclKlaimDirektur,
          props: true,
        },
        {
          path: "SpclManifestKlaimDirektur/:id",
          name: "SpclKlaimDirekturManifestAcc",
          component: DirekturKlaimManifest,
          props: true,
        },
        {
          path: "SpclPI",
          name: "SpclPIAcc",
          props: true,
          component: SpclPIDataList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPiManifest/:id",
          name: "SpclPiManifestAcc",
          props: true,
          component: PiManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclAddendum",
          name: "SpclAddendumAcc",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "manifest/:id",
          name: "SpclAddendumManifestAcc",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "account-receivable",
          component: AccountReceiveWrapper,
          children: [
            {
              path: "",
              name: "account-receive-indexar",
              props: true,
              component: AccountReceiveIndex,
            },
            {
              path: "manifest/:tab/:jns/:id",
              name: "account-receivable-manifest",
              props: true,
              component: AccountReceiveManifest,
            },
          ]
        },
        {
          path: "reconciliation",
          component: ReconciliationWrapper,
          children: [
            {
              path: "",
              name: "reconciliation-index",
              props: true,
              component: ReconciliationIndex,
            },
            {
              path: "detil/:id/:periode_reconsile",
              name: "reconciliation-detil",
              props: true,
              component: ReconciliationDetil,
            },
            {
              path: "manifest/:id",
              name: "reconciliation-manifest",
              props: true,
              component: ReconciliationManifest,
            }
          ]
        },
        {
          path: "cashonhandbank",
          component: CashOnHandWrapper,
          children: [
            {
              path: "",
              name: "cashonhand-index-acc",
              props: true,
              component: CashOnHandIndex,
            },
            {
              path: "manifest/:id&:pages",
              name: "cashonhand-manifest-acc",
              props: true,
              component: CashOnHandManifest,
            }
          ]
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContract-acc",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContract-acc",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistory-acc",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
          ]
        },
        {
          path: "tax_release",
          name: "taxRelease_AccKeu",
          meta: {
            onlyView: true
          },
          component: TaxRelease,
        },
        {
          path: "PIRelease",
          name: "PIRelease_AccKeu",
          component: PIRelease,
          props: true,
          meta: {
            page_type: "pi",
            onlyView: true
          },
        },
        {
          path: "Customer",
          component: landingCustomer,
          children: [
            {
              path: "",
              name: "customer",
              component: Customer,
            },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexAccKeu",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestAccKeu",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationAcc",
              props: true,
              component: RNDNotification,
            },
            {
              path: "create",
              name: "createRNDNotificationAcc",
              props: true,
              component: RNDNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationAcc",
              props: true,
              component: RNDNotificationManifest,
            },
            {
              path: "edit/:id",
              name: "editRNDNotificationAcc",
              props: true,
              component: RNDNotificationCreate,
            },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexAcc",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestAcc",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "SpclProyek",
          component: SpclProyekWrapperDirektur,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "spclProyekAcc",
              props: true,
              component: SpclProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifestanggaran/:id&:rabview&:budget_thn",
              name: "spclManifestProyekAcc",
              props: true,
              component: SpclManifestProyekDirektur,
              meta: {
                isSpecialMenu: true,
              },
            }
          ],
        },
        {
          path: "BkkReleaseKlaimCCPP",
          name: "BkkReleaseKlaimCCPPACC",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaim_cc_pp",
            page_title: "Credit Card PP Claim"
          },
        },
        {
          path: "BkkReleaseKlaimCCPD",
          name: "BkkReleaseKlaimCCPDACC",
          component: BkkReleaseAcc,
          props: true,
          meta: {
            page_type: "klaim_cc_pd",
            page_title: "Credit Card PD Claim"
          },
        },
        {
          path: "SpclKlaimCC",
          name: "SpclKlaimCCACC",
          component: SpclKlaimCc,
          props: true,
        },
        {
          path: "SpclKlaimCCManifest/:id",
          name: "SpclKlaimCCManifestACC",
          props: true,
          component: KlaimCCManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimCCPP",
          name: "SpclMenuMonKlaimCCPPACC",
          component: SpclKlaimCCPP,
          props: true,
        },
        {
          path: "SpclKlaimCCPPManifest/:id",
          name: "SpclKlaimCCPPManifestACC",
          props: true,
          component: KlaimManifestCCPp,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringklaimccpd",
          name: "monitoringKlaimCcPdACC",
          props: true,
          component: KlaimCCPDSpecial,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringklaimccpdManifest/:id",
          name: "SpclMenuMonKlaimCCPDManifestACC",
          props: true,
          component: KlaimCCManifestPd,
          meta: {
            isSpecialMenu: true,
          },
        },
        // {
        //   path: "monitoring/bailoutReport",
        //   name: "SpecialBailoutReportACC",
        //   beforeEnter: isAuthenticated,
        //   component: SpclBailoutReportList,
        // },
        // {
        //   path: "monitoring/manifestBailoutReport/:id",
        //   name: "SpecialManifestBailoutReportACC",
        //   props: true,
        //   beforeEnter: isAuthenticated,
        //   component: BailoutFundReportManifest,
        // },
        {
          path: "prospek",
          props: true,
          component: ProspectNotificationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "prospectNotificationACC",
              props: true,
              component: ProspectNotification,
            },
            {
              path: "manifest/:id",
              name: "manifestProspectNotificationACC",
              props: true,
              component: ProspectNotificationManifest,
            },
          ]
        },
        {
          path: "monitoring/bailoutReport",
          name: "SpecialBailoutReportACC",
          meta: {
            spcl_menu_monitoring:true,
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutReportList,
        },
        {
          path: "monitoring/manifestBailoutReport/:id",
          name: "SpecialManifestBailoutReportACC",
          props: true,
          beforeEnter: isAuthenticated,
          component: BailoutFundReportManifest,
        },
        {
          path: "monitoring/bailoutFund",
          name: "SpecialBailoutFundACC",
          meta: {
            spcl_menu_monitoring:true,
            page_type: "monitoring bailoutfund",
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutFundList,
        },
      ],
    },
    {
      path: "/akuntansi",
      component: Akuntansi,
      beforeEnter: isAuthenticated,
      meta: ["akuntansi"],
      children: [
        {
          path: "",
          name: "akuntansi",
          props: true,
          component: AkuntansiDashboard,
        },
        {
          path: "/masterCoa",
          name: "master_coa",
          props: true,
          component: MasterCoa,
        }, 
        {
          path: "/masterCostPool",
          name: "master_CostPool",
          props: true,
          component: MasterCostPool,
        },
        {
          path: "/arAccounting",
          component: ARAccountingWrapper,
          children: [
            {
              path: "",
              name: "arAccounting-index",
              props: true,
              component: ARAccountingIndex,
            },
            {
              path: "manifest/:tab/:jns/:id",
              name: "arAccounting-manifest",
              props: true,
              component: ARAccountingManifest,
            },
            {
              path: "creategeneral",
              name: "creategeneral-arAccounting",
              props: true,
              beforeEnter: isAuthenticated,
              component: ARAccountingCreateGeneral,
            },
            {
              path: "createNgeneral/:id",
              name: "createNgeneral-arAccounting",
              props: true,
              beforeEnter: isAuthenticated,
              component: ARAccountingCreateNGeneral,
            },
            {
              path: "editNgeneral/:id",
              name: "editNgeneral-arAccounting",
              props: true,
              beforeEnter: isAuthenticated,
              component: ARAccountingEditNGeneral,
            },
          ]
        },
      ]
    },
    {
      path: "/anggaran",
      component: Anggaran,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "aanggaran.listingAcc",
          props: true,
          component: AnggaranList,
        },
        {
          path: "create",
          name: "aanggaranCreateAcc",
          props: true,
          component: CreateAnggaran,
        },
        {
          path: "edit/:id",
          name: "aanggaranEditAcc",
          props: true,
          component: CreateAnggaran,
        },
      ],
    },
    {
      path: "/manifestanggaran/:id&:rabview",
      name: "aanggaran.manifestAcc",
      props: true,
      component: ManifestAnggaran,
    },
    {
      path: "/pp/pi",
      component: PI,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "pi",
          component: ListPI,
        },
        {
          path: "Create",
          name: "CreatePi",
          props: true,
          component: CreatePi,
        },
        {
          path: "Create/:id",
          name: "CreatePiFromlink",
          props: true,
          component: CreatePi,
        },
        {
          path: "Edit/:id",
          name: "EditPi",
          props: true,
          component: CreatePi,
        },
        {
          path: "manifest/:id",
          name: "PiManifest",
          props: true,
          component: PiManifest,
        },
        // {
        //   path: "create",
        //   name: "createPo",
        //   props: true,
        //   component: CreatePo,
        // },
      ],
    },
    // public side
    {
      path: "/pu/lapmanifestumpp/:id",
      name: "publicManifest",
      props: true,
      component: LaporanManifestPublic,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/lapmanifestumpd/:id",
      name: "lapPublicManifestUmpd",
      props: true,
      component: LMOUmpd,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaimmanifestpd/:id",
      name: "publicKlaimManifestPd",
      props: true,
      component: KlaimPuManifestPd,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/sppd/:id",
      name: "publicManifestSppd",
      props: true,
      component: SppdPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/pp/:id",
      name: "publicManifestPp",
      props: true,
      component: PpPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/um_pd/:id",
      name: "publicManifestUmpd",
      props: true,
      component: UmpdPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/um_pp/:id",
      name: "publicManifestUmpp",
      props: true,
      component: UmppPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/po/:id",
      name: "publicManifestPo",
      props: true,
      component: PoPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/wo/:id",
      name: "publicManifestWo",
      props: true,
      component: WoPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/salesnotif/:id",
      name: "publicManifestSalesNotif",
      props: true,
      component: SalesNotifPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/financing/:id",
      name: "publicManifestFinancing",
      props: true,
      component: FinancingPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/suplier/:id",
      name: "publicManifestSupplier",
      props: true,
      component: SupplierPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/lap_um_pp/:id",
      name: "publicManifestLapUmPP",
      props: true,
      component: LapUmPPPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/lap_um_pd/:id",
      name: "publicManifestLapUmPD",
      props: true,
      component: LapUmPDPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaim_biaya_pd/:id",
      name: "publicManifestKlaimBiayaPd",
      props: true,
      component: KlaimBiayaPDPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaim_biaya_pp/:id",
      name: "KlaimPuManifestPpApproval",
      props: true,
      component: KlaimPuManifestPpApproval,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/kk/:id",
      name: "publicManifestLapKk",
      props: true,
      component: KkPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/kas_kecil/:id",
      name: "publicManifestLapKasKecil",
      props: true,
      component: KasKecilPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/lap_kegiatan_pd/:id",
      name: "publicManifestLapKegiatanPD",
      props: true,
      component: LapPDPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaimmanifestdirektur/:id",
      name: "publicManifestDirektur",
      props: true,
      component: KlaimManifestDirektur,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/piutangKaryawan/:id",
      name: "publicManifestPiutangKaryawan",
      props: true,
      component: PiutangkaryawanPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/pembayaranPiutangKaryawan/:id",
      name: "publicManifestPembayaranPiutangKaryawan",
      props: true,
      component: PembayaranPiutangkaryawanPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/evaluasiSuplier/:id",
      name: "publicManifestEvaluasiSuplier",
      props: true,
      component: SupplierEvaluationPublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/MonthlyAnnualManifest/:type/:id",
      name: "publicMonthlyAnnualManifest",
      props: true,
      component: ManifestPublicAnnualMonthly,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaimmanifestcc/:id",
      name: "klaimmanifestcc",
      props: true,
      component: KlaimCCManifestPublic,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaim_cc/pp/manifest/:id",
      name: "klaimPuManifestCCPp",
      props: true,
      component: KlaimPuManifestCCPp,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/klaim_cc/sppd/manifest/:id",
      name: "KlaimCCPuManifestPd",
      props: true,
      component: KlaimCCPuManifestPd,
      meta: {
        isPublic: true,
      },
    },

    {
      path: "/pu/laporan/bailout/manifest/:id",
      name: "PublicManifestBailoutFund",
      props: true,
      component: BailoutFundReportManifestPublic,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/pipeline/manifest/:id",
      name: "PipelinePublicManifest",
      props: true,
      component: PipelinePublicManifest,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/pu/prospek/manifest/:id",
      name: "ProspectPublicNotificationManifest",
      props: true,
      component: ProspectPublicNotificationManifest,
      meta: {
        isPublic: true,
      },
    },
    { //here we go again
      path: "/pu/klaimCCTiket/:id",
      name: "klaim_cc_tiket_pu",
      props: true,
      component: KlaimCcTiketPuManifest
    },
    // end public side

    {
      path: "/laporan/umpd",
      component: LaporanUMPD,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "laporanUmpd",
          component: LaporanListUmPd,
        },
        {
          path: "create",
          name: "lapUmpdCreate",
          props: true,
          component: LaporanUmpdCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestLaporanUmpd",
          props: true,
          component: ManifestLaporanUmpd,
        },
        {
          path: "edit/:id",
          name: "lapUmpdEdit",
          props: true,
          component: LaporanUmpdCreate,
        },
        {
          path: "edit/:type/:id",
          name: "lapDraftUmpdEdit",
          props: true,
          component: LaporanUmpdCreate,
        },
      ],
    },
    {
      path: "/staff-marketing",
      component: StaffMarketing,
      props: true,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "marketing",
          props: true,
          component: StaffMarketingBoard,
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContract2",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContract2",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistory2",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            {
              path: "create",
              name: "createSalesContract2",
              component: SalesContractCreate,
            },
            {
              path: ":id/edit",
              name: "editSalesContract2",
              props: true,
              component: SalesContractCreate,
            },
            {
              path: "edit/:type/:id",
              name: "editSalesContractByType2",
              props: true,
              component: SalesContractCreate,
            },
          ]
        },
        {
          path: "bidBondRequest",
          component: BidBondRequestIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBondRequest-list-mar",
              props: true,
              meta: {
                ismarketing: true,
              },
              component: BidBondRequestList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBondRequest-create-mar",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBondRequest-edit-mar",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBondRequest-manifest-mar",
              props: true,
              component: BidBondRequestFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "bidBond",
          component: BidBondIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBond-list-mar",
              props: true,
              meta: {
                ismarketing: true,
              },
              component: BidBondList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBond-create-mar",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBond-edit-mar",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBond-manifest-mar",
              props: true,
              component: BidBondFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
      ]
    },
    {
      path: "/marketing",
      component: Marketing,
      props: true,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "marketingmar",
          props: true,
          component: MarketingBoard,
        },
        {
          path: "salesNotification",
          props: true,
          component: SalesNotificationIndex,
          children: [
            {
              path: "",
              name: "salesNotification",
              props: true,
              component: SalesNotification,
            },
            {
              path: "create",
              name: "createSalesNotification",
              props: true,
              component: SalesNotificationCreate,
            },
            {
              path: "createfrom/:sn_id/:cust_id",
              name: "createSalesNotificationfrom",
              props: true,
              component: SalesNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestSalesNotification",
              props: true,
              component: SalesNotificationManifest,
            },
            {
              path: "edit/:id",
              name: "editSalesNotification",
              props: true,
              component: SalesNotificationCreate,
            },
          ]
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabMar",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestMar",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContract",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContractMar",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistory",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            {
              path: "create",
              name: "createSalesContractmar",
              component: SalesContractCreate,
            },
            {
              path: ":id/edit",
              name: "editSalesContractmar",
              props: true,
              component: SalesContractCreate,
            },
            {
              path: "edit/:type/:id",
              name: "editSalesContractByTypemar",
              props: true,
              component: SalesContractCreate,
            },
          ]
        },
        {
          path: "TerminRelease",
          component: TerminReleaseIndex,
          children: [
            {
              path: "",
              name: "terminRelease-List",
              props: true,
              component: TerminReleaseList,
            },
            {
              path: "create",
              name: "terminReleaseCreateMar",
              component: TerminReleaseCreate,
            },
            {
              path: "edit/:id",
              name: "terminReleaseEditMar",
              props: true,
              component: TerminReleaseCreate,
            },
            {
              path: "manifest/:id",
              name: "terminReleaseManifestMar",
              props: true,
              component: TerminReleaseManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "bidBondRequest",
          component: BidBondRequestIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBondRequest-list",
              props: true,
              meta: {
                ismarketing: true,
              },
              component: BidBondRequestList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBondRequest-create",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBondRequest-edit",
              props: true,
              component: BidBondRequestCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBondRequest-manifest",
              props: true,
              component: BidBondRequestFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "bidbond",
          component: BidBondIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "bidBond-list",
              props: true,
              meta: {
                ismarketing: false,
              },
              component: BidBondList,
              beforeEnter: isAuthenticated,
            },
            {
              path: "create",
              name: "bidBond-create",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "edit/:type/:id",
              name: "bidBond-edit",
              props: true,
              component: BidBondCreate,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "bidBond-manifest",
              props: true,
              component: BidBondFinancing,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-index",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifest",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "prospek",
          props: true,
          component: ProspectNotificationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "prospectNotification",
              props: true,
              component: ProspectNotification,
            },
            {
              path: "create",
              name: "createProspectNotification",
              props: true,
              component: ProspectNotificationCreate,
            },
            {
              path: "edit/:id",
              name: "editProspectNotification",
              props: true,
              component: ProspectNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestProspectNotification",
              props: true,
              component: ProspectNotificationManifest,
            },
          ]
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationMar",
              props: true,
              component: RNDNotification,
            },
            {
              path: "create",
              name: "createRNDNotificationMar",
              props: true,
              component: RNDNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationMar",
              props: true,
              component: RNDNotificationManifest,
            },
            {
              path: "edit/:id",
              name: "editRNDNotificationMar",
              props: true,
              component: RNDNotificationCreate,
            },
          ]
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDMar",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestMar",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringklaimccpd",
          name: "monitoringKlaimCcPdMar",
          props: true,
          component: KlaimCCPDSpecial,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringklaimccpdManifest/:id",
          name: "monitoringManifestKlaimCcPdMar",
          props: true,
          component: KlaimCCManifestPd,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdMar",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestMar",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDMar",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestMar",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDMar",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestMar",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDMar",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestMar",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        }
      ],
    },
    {
      path: "/klaim/Pp",
      component: KlaimPp,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "klaimPp",
          component: KlaimListPp,
        },
        {
          path: "create",
          name: "klaimPpCreate",
          props: true,
          component: KlaimPpCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestKlaimPp",
          props: true,
          component: KlaimManifestPp,
        },
        {
          path: "edit/:id",
          name: "klaimPpEdit",
          props: true,
          component: KlaimPpCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimDraftPpEdit",
          props: true,
          component: KlaimPpCreate,
        },
        {
          path: "/pu/klaimmanifestpp/:id",
          name: "publicKlaimManifestPp",
          props: true,
          component: KlaimPuManifestPp,
          meta: {
            isPublic: true,
          },
        },
        {
          path: "/pu/bidbondRequest/:id",
          name: "publicBidbondRequest",
          props: true,
          component: BidBondRequestPublicManifest,
          meta: {
            isPublic: true,
          },
        },
        {
          path: "/pu/project/:id",
          name: "publicProject",
          props: true,
          component: ProjectPublicManifest,
          meta: {
            isPublic: true,
          },
        },
      ],
    },
    {
      path: "/klaim/sppd",
      component: KlaimPd,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "klaimUmpd",
          component: KlaimListPd,
        },
        {
          path: "manifest/:id",
          name: "manifestKlaimPd",
          props: true,
          component: KlaimManifestPd,
        },
        {
          path: "create",
          name: "klaimPdCreate",
          props: true,
          component: KlaimPdCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimPdEdit",
          props: true,
          component: KlaimPdCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimDraftPdEdit",
          props: true,
          component: KlaimPdCreate,
        },
      ],
    },
    {
      path: "/laporan/kaskecil",
      component: LaporanKasKecil,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "laporanKasKecil",
          component: LaporanListKasKecil,
        },
        {
          path: "manifest/:id",
          name: "manifestLaporanKasKecil",
          props: true,
          component: LaporanManifestKasKecil,
        },
        {
          path: "create",
          name: "kasKecilCreate",
          props: true,
          component: KasKecilCreate,
        },
        {
          path: "edit/:id",
          name: "kasKecilEdit",
          props: true,
          component: KasKecilCreate,
        },
        {
          path: "edit/:type/:id",
          name: "kasKecilDraftEdit",
          props: true,
          component: KasKecilCreate,
        },
      ],
    },
    {
      path: "/kaskecil",
      component: SpclKasKecilDataList,
      beforeEnter: isAuthenticated,
      props: true,
      meta: {
        key: "66",
      },
    },
    {
      path: "/manifestkk/:id",
      name: "kaskecilmanifest",
      props: true,
      beforeEnter: isAuthenticated,
      component: SpclKasKecilManifest,
      meta: {
        isSpecialMenu: true,
      },
    },
    {
      path: "/account-pay/create/:type/:id",
      name: "account-pay-create",
      props: true,
      beforeEnter: isAuthenticated,
      component: AccountPayCreate,
    },
        {
      path: "/account-pay/Edit/:type/:id",
      name: "account-pay-edit",
      props: true,
      beforeEnter: isAuthenticated,
      component: AccountPayCreate,
    },
    {
      path: "/klaim-direktur",
      beforeEnter: isAuthenticated,
      component: WrapperKlaimDirektur,
      children: [
        {
          path: "",
          name: "klaim-direktur",
          props: true,
          component: KlaimDirektur,
        },
        {
          path: "create",
          name: "klaim-direktur-create",
          props: true,
          component: CreateKlaimDirektur,
        },
        {
          path: "edit/:type/:id",
          name: "klaim-direktur-edit",
          props: true,
          component: CreateKlaimDirektur,
        },
        {
          path: "manifestDirectur/:id",
          name: "manifestDirectur",
          props: true,
          component: DirekturKlaimManifest,
        },
      ]
    },
    {
      path: "/klaimCC",
      beforeEnter: isAuthenticated,
      component: KlaimCCIndex,
      children: [
        {
          path: "",
          name: "klaimCC",
          props: true,
          component: KlaimCC,
        },
        {
          path: "create",
          name: "klaimCCCreate",
          props: true,
          component: KlaimCCCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimCCCreateEdit",
          props: true,
          component: KlaimCCCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestKlaimCC",
          props: true,
          component: KlaimCCManifest,
        },
      ]
    },
    {
      path: "/klaimCCPP",
      component: KlaimPp,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "klaimCCPp",
          component: KlaimListCCPp,
        },
        {
          path: "create",
          name: "klaimCCPpCreate",
          props: true,
          component: KlaimCCPpCreate,
        },
        {
          path: "manifest/:id",
          name: "manifestKlaimCCPp",
          props: true,
          component: KlaimManifestCCPp,
        },
        {
          path: "edit/:id",
          name: "klaimCCPpEdit",
          props: true,
          component: KlaimCCPpCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimDraftCCPpEdit",
          props: true,
          component: KlaimCCPpCreate,
        },
        {
          path: "/pu/klaimmanifestCCpp/:id",
          name: "publicKlaimManifestCCPp",
          props: true,
          component: KlaimPuManifestCCPp,
          meta: {
            isPublic: true,
          },
        },
      ],
    },
    {
      path: "/klaimCCPD",
      component: KlaimCCPd,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "klaimCCPDList",
          component: KlaimCCListPd,
        },
        {
          path: "manifest/:id",
          name: "manifestCCKlaimPd",
          props: true,
          component: KlaimCCManifestPd,
        },
        {
          path: "create",
          name: "klaimCCPdCreate",
          props: true,
          component: KlaimCCPdCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimCCPdEdit",
          props: true,
          component: KlaimCCPdCreate,
        },
        {
          path: "edit/:type/:id",
          name: "klaimDraftCCPdEdit",
          props: true,
          component: KlaimCCPdCreate,
        },
      ],
    },
    {
      path: "/admin",
      beforeEnter: isAuthenticated,
      component: Wrapper,
      children: [
        {
          path: "",
          name: "board",
          props: true,
          component: Admin,
        },
        {
          path: "master-interval-workflow",
          name: "master-interval-workflow",
          props: true,
          component: MasterIntervalWorkflow,
        },
      ]
    },
    {
      path: "/vpf",
      component: Vpf,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "vpf",
          component: VpfBoard,
        },
        {
          path: "monitoringpp",
          name: "SpclPPVpf",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestVpf",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDVpf",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestVpf",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPVpf",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestVpf",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDVpf",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestVpf",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPVpf",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestVpf",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDVpf",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestVpf",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclWO",
          name: "SpclWOVpf",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestVpf",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOVpf",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestVpf",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilVpf",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestVpf",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSupplier",
          name: "SpclSupplierVpf",
          component: Supplier,
          props: true,
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "SpclSupplierManifestVpf",
          props: true,
          component: PurchasingManifest,
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabVpf",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestVpf",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesNotification",
          name: "SpclSalesNotificationVpf",
          component: SpclSalesNotificationDataList,
          props: true,
        },
        {
          path: "SpclSalesNotificationManifest/:id",
          name: "SpclSalesNotificationManifestVpf",
          props: true,
          component: SpclSalesNotificationManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDVpf",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestVpf",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdVpf",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestVpf",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPVpf",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestVpf",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclProyek",
          component: SpclProyekWrapperVpf,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "spclProyekVpf",
              props: true,
              component: SpclProyekVpf,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifestanggaran/:id&:rabview&:budget_thn",
              name: "spclManifestProyekVpf",
              props: true,
              component: SpclManifestProyekVpf,
              meta: {
                isSpecialMenu: true,
              },
            }
          ],
        },
        {
          path: "scplprio",
          name: "scplprioVpf",
          props: true,
          component: SpclPrio_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContractVpf",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContractVpf",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistoryVpf",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            {
              path: "create",
              name: "createSalesContractVpf",
              component: SalesContractCreate,
            },
            {
              path: ":id/edit",
              name: "editSalesContractVpf",
              props: true,
              component: SalesContractCreate,
            },
            {
              path: "edit/:type/:id",
              name: "editSalesContractByTypeVpf",
              props: true,
              component: SalesContractCreate,
            },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexVpf",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestVpf",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafon_Vpf",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafon_Vpf",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifest_Vpf",
          props: true,
          component: ManifestAnnualMonthly,
        },
        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationVpf",
              props: true,
              component: RNDNotification,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationVpf",
              props: true,
              component: RNDNotificationManifest,
            },
          ]
        }
      ],
    },
    {
      path: "/evaluasiSupplier/manifest/:id",
      name: "supplierEvaluation-manifest",
      props: true,
      component: SupplierEvaluationManifest,
      beforeEnter: isAuthenticated,
    },
    {
      path: "/tax-officer",
      component: TaxOfficer,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "taxOfficerBoard",
          component: TaxOfficerBoard,
        },
        {
          path: "/mon-tax/:generate",
          name: "mon-Tax",
          props: true,
          component: MonitoringTax,
        },
        {
          path: "/mon-verif-tax",
          name: "mon-verif-tax",
          component: MonitoringTaxVerification,
        },
        {
          path: "/MonitoringFaktur",
          name: "MonitoringFaktur",
          component: MonitoringFaktur,
        },
        {
          path: "/SPT",
          name: "SPT",
          component: SPT,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "Create",
              name: "SPTCreate",
              component: SPTCreate,
            },
            {
              path: "SPTEdit/:id",
              name: "SPTEdit",
              props: true,
              component: SPTEdit,
            },
            {
              path: "Manifest/:id/:tipe",
              name: "SPTManifest",
              props: true,
              component: SPTManifest,
            },
          ]
        },
        {
          path: "/master-setoran",
          name: "masterSetoran",
          component: MasterKodeSetoran,
        },
        {
          path: "/compensation",
          name: "compensation",
          component: Compensation,
        },
        {
          path: "/tax_release",
          name: "taxRelease",
          component: TaxRelease,
        },
        {
          path: "/SPT-PPH",
          name: "SPT-PPH",
          component: SPTMonIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "masa",
              name: "sptppnmasa",
              meta: {
                title: "SPT PPN Masa List",
                jns: "ppn",
              },
              component: SPTList,
            },
            {
              path: "Recap/masa",
              name: "spt_recap_ppn_masa",
              meta: {
                title: "Recapitulation SPT PPN Masa",
                jns: "ppn",
              },
              component: SPTRecapList,
            },
            {
              path: "21",
              name: "sptpph21",
              meta: {
                title: "SPT PPh 21 List",
                jns: "pph_21",
              },
              component: SPTList,
            },
            {
              path: "Recap/21",
              name: "spt_recap_pph21",
              meta: {
                title: "Recapitulation SPT PPh 21",
                jns: "pph_21",
              },
              component: SPTRecapList,
            },
            {
              path: "unifikasi",
              name: "sptpphunifikasi",
              meta: {
                title: "SPT PPh Unifikasi List",
                jns: "pph_unifikasi",
              },
              component: SPTList,
            },
            {
              path: "Recap/unifikasi",
              name: "spt_recap_pphunifikasi",
              meta: {
                title: "Recapitulation SPT PPh Unifikasi",
                jns: "pph_unifikasi",
              },
              component: SPTRecapList,
            },
            {
              path: "tahunan",
              name: "sptpphtahunan",
              meta: {
                title: "SPT PPh Tahunan List",
                jns: "spt_tahunan",
              },
              component: SPTList,
            },
          ]
        },
        {
          path: "PBK",
          name: "pbk",
          component: PBKList,
          beforeEnter: isAuthenticated,
        }, 
        {
          path: "PBK/Create",
          name: "PBKCreate",
          component: PBKCreate,
          beforeEnter: isAuthenticated,
        },
        {
          path: "PBK/Manifest/:id",
          name: "pbkManifest",
          props: true,
          component: PBKManifest,
          beforeEnter: isAuthenticated,
        },
      ]
    },
    {
      path: "/projectProgress",
      
      component: ProjectProgressWrapper,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "projectProgress-index",
          props: true,
          component: ProjectProgressIndex,
        },
      ]
    },
    {
      path: "/viewproyekrab",
      name: "viewproyekrabAcc",
      component: ProyekRab,
      beforeEnter: isAuthenticated,
      props: true,
      redirect: {
        name: "viewproyekrab.listingAcc",
      },
      children: [
        {
          path: "",
          name: "viewproyekrab.listingAcc",
          props: true,
          component: ListProyekRab,
        },
        {
          path: "manifestrab/:id&:rabview",
          name: "viewproyekrab.manifestrabAcc",
          props: true,
          component: ManifestRab,
        },
      ],
    },
    {
      path: "/ChangeLogs",
      name: "ChangeLogs",
      meta: {
        isPublic: true,
      },
      component: ChangeLogs,
    },
    {
      path: "/ppDashBoard",
      name: "ppDashBoard",
      props: true,
      component: ppDashBoard,
      meta: {
        isPublic: true,
      },
    },
    {
      path: "/financialControl",
      component: FinancialControl,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "financialControl",
          component: FinancialControlBoard,
        },
        {
          path: "monitoringpp",
          name: "SpclPPFin",
          component: SpclPPDataList,
          props: true,
        },
        {
          path: "monppmanifest/:id",
          name: "SpclPPManifestFin",
          props: true,
          component: SpclPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringsppd",
          name: "SpclMenuMonSPPDFin",
          component: SpclSPPDDataList,
          props: true,
        },
        {
          path: "monsppdmanifest/:id",
          name: "SpclSPPDManifestFin",
          props: true,
          component: SpclSppdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclUMPP",
          name: "SpclUMPPFin",
          component: SpclUMPPDataList,
          props: true,
        },
        {
          path: "SpclUMPPManifest/:id",
          name: "SpclUMPPManifestFin",
          props: true,
          component: SpclUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonUMPD",
          name: "SpclMenuMonUMPDFin",
          component: SpclUMPDDataList,
          props: true,
        },
        {
          path: "SpclUMPDManifest/:id",
          name: "SpclUMPDManifestFin",
          props: true,
          component: SpclUMPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclLapUMPP",
          name: "SpclLapUMPPFin",
          component: SpclLapUMPPDataList,
          props: true,
        },
        {
          path: "SpclLapUMPPManifest/:id",
          name: "SpclLapUMPPManifestFin",
          props: true,
          component: SpclLapUMPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonLapUMPD",
          name: "SpclMenuMonLapUMPDFin",
          component: SpclLapUMPDDataList,
          props: true,
        },
        {
          path: "SpclLapUMPDManifest/:id",
          name: "SpclLapUMPDManifestFin",
          props: true,
          component: SpclLapUMPDManifest,
        },
        {
          path: "SpclWO",
          name: "SpclWOFin",
          component: SpclWODataList,
          props: true,
        },
        {
          path: "SpclWOManifest/:id",
          name: "SpclWOManifestFin",
          props: true,
          component: SpclWOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPO",
          name: "SpclPOFin",
          component: SpclPODataList,
          props: true,
        },
        {
          path: "SpclPOManifest/:id",
          name: "SpclPOManifestFin",
          props: true,
          component: SpclPOManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKasKecil",
          name: "SpclKasKecilFin",
          component: SpclKasKecilDataList,
          props: true,
        },
        {
          path: "SpclKasKecilManifest/:id",
          name: "SpclKasKecilManifestFin",
          props: true,
          component: SpclKasKecilManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimCC",
          name: "SpclKlaimCCFin",
          component: SpclKlaimCc,
          props: true,
        },
        {
          path: "SpclKlaimCCManifest/:id",
          name: "SpclKlaimCCManifestFin",
          props: true,
          component: KlaimCCManifest,
          meta: {
            isSpecialMenu: true,
          },
        },

        { //here
          path: "SpclKlaimCCPP",
          name: "SpclMenuMonKlaimCCPPFin",
          component: SpclKlaimCCPP,
          props: true,
        },
        {
          path: "SpclKlaimCCPPManifest/:id",
          name: "SpclKlaimCCPPManifestFin",
          props: true,
          component: KlaimManifestCCPp,
          meta: {
            isSpecialMenu: true,
          },
        },

        {
          path: "SpclSupplier",
          name: "SpclSupplierFin",
          component: Supplier,
          props: true,
        },
        {
          path: "SpclSupplierManifest/:id",
          name: "manifestSpclSupplierFin",
          props: true,
          component: PurchasingManifest,
        },
        {
          path: "SpclProyekRab",
          name: "SpclProyekRabFin",
          component: SpclProyekRabDataList,
          props: true,
        },
        {
          path: "SpclProyekRabManifest/:id&:rabview",
          name: "SpclProyekRabManifestFin",
          props: true,
          component: SpclProyekRabManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclSalesNotification",
          name: "SpclSalesNotificationFin",
          component: SpclSalesNotificationDataList,
          props: true,
        },
        {
          path: "SpclSalesNotificationManifest/:id",
          name: "SpclSalesNotificationManifestFin",
          props: true,
          component: SpclSalesNotificationManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclMenuMonKlaimPD",
          name: "SpclMenuMonKlaimPDFin",
          component: SpclKlaimPDDataList,
          props: true,
        },
        {
          path: "SpclKlaimPDManifest/:id",
          name: "SpclKlaimPDManifestFin",
          props: true,
          component: SpclKlaimPDManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "lapKegPd",
          name: "SpclLapKegPdFin",
          component: SpclLapKegPdDataList,
          props: true,
        },
        {
          path: "SpclLapKegPdManifest/:id",
          name: "SpclLapKegPdManifestFin",
          props: true,
          component: SpclLapKegPdManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclKlaimPP",
          name: "SpclMenuMonKlaimPPFin",
          component: SpclKlaimPPDataList,
          props: true,
        },
        {
          path: "SpclKlaimPPManifest/:id",
          name: "SpclKlaimPPManifestFin",
          props: true,
          component: SpclKlaimPPManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "anggaran",
          component: Anggaran,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "aanggaran.listingFin",
              props: true,
              component: AnggaranList,
            },
            {
              path: "create",
              name: "aanggaranCreateFin",
              props: true,
              component: CreateAnggaran,
            },
            {
              path: "edit/:id",
              name: "aanggaranEditFin",
              props: true,
              component: CreateAnggaran,
            },
          ],
        },
        {
          path: "/manifestanggaran/:id&:rabview&:budget_thn",
          name: "anggaran.manifestFin",
          props: true,
          component: ManifestAnggaran,
        },
        {
          path: "scplprio",
          name: "scplprioFin",
          props: true,
          component: SpclPrio_v2,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "salescontract",
          component: landingSalesContract,
          children: [
            {
              path: "",
              name: "salesContractFin",
              component: SalesContract,
            },
            {
              path: ":id/manifest",
              component: SalesContractManifestWrapper,
              children: [
                {
                  path: "",
                  name: "manifestSalesContractFin",
                  props: true,
                  component: SalesContractManifest,
                },
                {
                  path: ":id_/history",
                  name: "manifestSalesContractHistoryFin",
                  props: true,
                  component: SalesContractManifestHistory,
                }
              ]
            },
            // {
            //   path: "create",
            //   name: "createSalesContractFin",
            //   component: SalesContractCreate,
            // },
            // {
            //   path: ":id/edit",
            //   name: "editSalesContract",
            //   props: true,
            //   component: SalesContractCreate,
            // },
            // {
            //   path: "edit/:type/:id",
            //   name: "editSalesContractByType",
            //   props: true,
            //   component: SalesContractCreate,
            // },
          ]
        },
        {
          path: "pipeline",
          component: PipelineWrapper,
          children: [
            {
              path: "",
              name: "pipeline-indexFin",
              props: true,
              component: PipelineIndex,
            },
            {
              path: "manifest/:id",
              name: "pipeline-manifestFin",
              props: true,
              component: PipelineManifest,
            },
          ]
        },
        {
          path: "AnnualPlafon",
          name: "AnnualPlafonFin",
          props: true,
          component: AnnualPlafon,
        },
        {
          path: "MonthlyPlafon",
          name: "MonthlyPlafonFin",
          props: true,
          component: MonthlyPlafon,
        },
        {
          path: "MonthlyAnnualManifest/:type/:id",
          name: "MonthlyAnnualManifestFin",
          props: true,
          component: ManifestAnnualMonthly,
        },
        {
          path: "SpclAddendumFin",
          name: "SpclAddendumFin",
          props: true,
          component: SpclAdendumList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "manifestad/:id",
          name: "SpclAddendumManifestFin",
          props: true,
          component: ManifestAddendum,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "viewproyekrab",
          name: "viewproyekrabFin",
          component: ProyekRab,
          beforeEnter: isAuthenticated,
          props: true,
          redirect: {
            name: "viewproyekrab.listingFin",
          },
          children: [
            {
              path: "",
              name: "viewproyekrab.listingFin",
              props: true,
              component: ListProyekRab,
            },
            {
              path: "manifestrab/:id&:rabview",
              name: "viewproyekrab.manifestrabFin",
              props: true,
              component: ManifestRab,
            },
          ],
        },
        {
          path: "SpclPenarikanFinancing",
          name: "SpclPenarikanFinancing",
          props: true,
          beforeEnter: isAuthenticated,
          component: SpclPenarikanFinancingList,
        },
        {
          path: "manifest/:id",
          name: "SpclManifestPenarikanFinancing",
          props: true,
          meta:{
            isSpecialMenu: true,
          },
          beforeEnter: isAuthenticated,
          component: PenarikanFinancingManifest,
        },
        {
          path: "SpclFinancing",
          name: "spclfinancinglist",
          props: true,
          component: SpclFinancingList,
          beforeEnter: isAuthenticated,
        },
        {
          path: "SpclFinancingManifest/:id",
          name: "spclfinancingManifest",
          props: true,
          meta: {
            isSpecialMenu: true,
          },
          component: ManifestFinancing,
          beforeEnter: isAuthenticated,
        },
        {
          path: "evaluasiSupplier",
          component: SupplierEvaluationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "supplierEvaluationFin",
              props: true,
              component: SupplierEvaluation,
              beforeEnter: isAuthenticated,
            },
            {
              path: "manifest/:id",
              name: "supplierEvaluation-manifestFin",
              props: true,
              component: SupplierEvaluationManifest,
              beforeEnter: isAuthenticated,
            },
          ]
        },
        {
          path: "bkm",
          component: BKMWrapper,
          children: [
            {
              path: "",
              name: "bkmFin",
              props: true,
              component: BKMIndex,
            },
            {
              path: "bkmManifest/:id",
              name: "bkmManifestFin",
              props: true,
              component: BkmManifest,
              meta: {
                isSpecialMenu: true,
              },
            },
          ]
        },
        {
          path: "bkk",
          name: "BkkFin",
          component: Bkk,
          props: true,
          meta: {
            page_type: "ukk",
          },
        },
        {
          path: "bkkManifest/:id",
          name: "bkkManifestFin",
          props: true,
          component: BkkManifest,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "reconciliation",
          component: ReconciliationWrapper,
          children: [
            {
              path: "",
              name: "reconciliation-indexFin",
              props: true,
              component: ReconciliationIndex,
            },
            {
              path: "detil/:id/:periode_reconsile",
              name: "reconciliation-detilFin",
              props: true,
              component: ReconciliationDetil,
            },
            {
              path: "manifest/:id",
              name: "reconciliation-manifestFin",
              props: true,
              component: ReconciliationManifest,
            }
          ]
        },
        {
          path: "SpclPI",
          name: "SpclPIFin",
          props: true,
          component: SpclPIDataList,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "SpclPiManifest/:id",
          name: "SpclPiManifestFin",
          props: true,
          component: PiManifest,
          meta: {
            isSpecialMenu: true,
          },
        },

        { //here
          path: "monitoringklaimccpd",
          name: "monitoringKlaimCcPdFin",
          props: true,
          component: KlaimCCPDSpecial,
          meta: {
            isSpecialMenu: true,
          },
        },
        {
          path: "monitoringklaimccpdManifest/:id",
          name: "monitoringManifestKlaimCcPdFin",
          props: true,
          component: KlaimCCManifestPd,
          meta: {
            isSpecialMenu: true,
          },
        },

        {
          path: "rndNotification",
          props: true,
          component: RNDNotificationIndex,
          children: [
            {
              path: "",
              name: "rndNotificationFin",
              props: true,
              component: RNDNotification,
            },
            {
              path: "create",
              name: "createRNDNotificationFin",
              props: true,
              component: RNDNotificationCreate,
            },
            {
              path: "manifest/:id",
              name: "manifestRNDNotificationFin",
              props: true,
              component: RNDNotificationManifest,
            },
            {
              path: "edit/:id",
              name: "editRNDNotificationFin",
              props: true,
              component: RNDNotificationCreate,
            },
          ]
        },
        {
          path: "account-pay",
          component: AccountPayWrapper,
          meta: {
            isSpecialMenu: true,
          },
          children: [
            {
              path: "",
              name: "Spclaccount-pay-indexFin",
              props: true,
              component: AccountPayIndex,
              meta: {
                isSpecialMenu: true,
              },
            },
            {
              path: "manifest/:id",
              name: "Spclaccount-pay-manifestFin",
              props: true,
              component: AccountPayManifest,
              meta: {
                isSpecialMenu: true,
              },
            }
          ]
        },
        {
          path: "accReceive",
          component: AccountReceiveWrapper,
          children: [
            {
              path: "",
              name: "account-receive-indexFin",
              props: true,
              component: AccountReceiveIndex,
            },
            {
              path: "manifest/:tab/:jns/:id",
              name: "account-receive-manifestFin",
              props: true,
              component: AccountReceiveManifest,
            },
            {
              path: "creategeneral",
              name: "creategeneral-account-receiveFin",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveCreateGeneral,
            },
            {
              path: "createNgeneral/:id",
              name: "createNgeneral-account-receiveFin",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveCreateNGeneral,
            },
            {
              path: "editNgeneral/:id",
              name: "editNgeneral-account-receiveFin",
              props: true,
              beforeEnter: isAuthenticated,
              component: AccountReceiveEditNGeneral,
            },
          ]
        },
        {
          path: "closing-um",
          component: ClosingUMWrapper,
          beforeEnter: isAuthenticated,
          meta: {
            isSpecialMenu: true,
            isFC: true
          },
          children: [
            {
              path: "",
              name: "closing-um-indexFC",
              props: true,
              component: ClosingUM,
              meta: {
                isSpecialMenu: true,
                isFC: true
              },
            }
          ]
        },
        {
          path: "/closingUMManifest/:id",
          name: "closingUMManifestFC",
          props: true,
          component: Closingmanifest,
        },
        {
          path: "monitoring/bailoutReport",
          name: "SpecialBailoutReportFC",
          beforeEnter: isAuthenticated,
          component: SpclBailoutReportList,
        },
        {
          path: "monitoring/manifestBailoutReport/:id",
          name: "SpecialManifestBailoutReportFC",
          props: true,
          beforeEnter: isAuthenticated,
          component: BailoutFundReportManifest,
        },
        {
          path: "monitoring/bailoutFund",
          name: "SpecialBailoutFundFC",
          meta: {
            spcl_menu_monitoring:true,
            page_type: "monitoring bailoutfund",
          },
          beforeEnter: isAuthenticated,
          component: SpclBailoutFundList,
        },
        {
          path: "prospek",
          props: true,
          component: ProspectNotificationIndex,
          beforeEnter: isAuthenticated,
          children: [
            {
              path: "",
              name: "prospectNotificationFC",
              props: true,
              component: ProspectNotification,
            },
            {
              path: "manifest/:id",
              name: "manifestProspectNotificationFC",
              props: true,
              component: ProspectNotificationManifest,
            },
          ]
        },
        {
          path: "account-receivable",
          component: AccountReceiveWrapper,
          children: [
            {
              path: "",
              name: "account-receive-indexFC",
              props: true,
              component: AccountReceiveIndex,
            },
            {
              path: "manifest/:tab/:jns/:id",
              name: "account-receivable-manifestFC",
              props: true,
              component: AccountReceiveManifest,
            },
          ]
        },
        {
          path: "SpclKlaimDirektur",
          name: "Spcl_Klaim_DirekturFC",
          component: SpclKlaimDirektur,
          props: true,
        },
        {
          path: "SpclManifestKlaimDirektur/:id",
          name: "SpclKlaimDirekturManifestFC",
          component: DirekturKlaimManifest,
          props: true,
        },
      ],
    },
    {
      path: "/bailoutfund",
      name: "bailoutfund",
      component: BailoutFundRelease,
      beforeEnter: isAuthenticated,
      props: true,
      meta: {
        page_type: "bailoutfund",
      },
    },
    {
      path: "/bailoutfundreport",
      component: BailoutFundReportIndex,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "bailoutfundreport",
          props: true,
          component: BailoutFundReportList,
        },
        {
          path: "create",
          name: "bailoutfundreportCreate",
          props: true,
          component: BailoutFundReportCreate,
        },
        {
          path: "edit/:type/:id",
          name: "bailoutfundreportEdit",
          props: true,
          component: BailoutFundReportEdit,
        },
        {
          path: "manifest/:id",
          name: "bailoutfundreportManifest",
          props: true,
          component: BailoutFundReportManifest,
        },
      ]
    },
    {
      path: "/cc",
      component: CC,
      beforeEnter: isAuthenticated,
      children: [
        {
          path: "",
          name: "CCBoard",
          component: CCBoard,
        },
        {
          path: "reconciliation",
          name: "CCReconciliation",
          component: CCReconciliation,
        },
        {
          path: "reconciliation-create",
          component: CCWrapper,
          children: [
            {
              path: "",
              name: "CCCreateReconciliation",
              component: CCCreateReconciliation,
            },
            {
              path: ":type/:id",
              name: "CCCreateDraftReconciliation",
              component: CCCreateReconciliation,
              props: true,
            }
          ]
        },
        {
          path: "manifest-reconciliation/:type/:id",
          name: "CCManifestReconciliation",
          props: true,
          component: CCManifestReconciliation,
        },
      ]
    }
  ],
});

router.beforeEach((to, from, next) => {
  store.dispatch("PRELOADER", true);
  next();
})

router.afterEach(() => {
  store.dispatch("PRELOADER", false);
})

export default router
